import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import HomePage from "./HomePage";
import "./styles.css";
import { getStorage, ref, getDownloadURL, listAll } from "firebase/storage";
import DocHero from "./Documentation/DocHero";
import DocNav from "./Documentation/DocNav";
import DocSection from "./Documentation/DocSection";
import StepCard from "./Documentation/StepCard";
import FeatureHighlight from "./Documentation/FeatureHighlight";
import RecentWorkflowGuide from "./Documentation/RecentWorkflowGuide";
import PortalGuide from "./Documentation/PortalGuide";

const FILINGSTACK_MANUAL_URL =
  "https://firebasestorage.googleapis.com/v0/b/filing-stack.appspot.com/o/DocumentationImages%2FFilingStack%20Manual.pdf?alt=media&token=686ed631-c987-4de6-80b5-79c2e10aebc0";

const UsageInfo = () => {
  const [stylingOnClickUsageInfo, setstylingOnClickUsageInfo] = useState();
  const [darkMode] = useState(
    typeof window !== "undefined" &&
      (localStorage.getItem("theme") === "dark" ||
        (window.matchMedia &&
          window.matchMedia("(prefers-color-scheme: dark)").matches))
  );
  const [collapsedSections, setCollapsedSections] = useState({
    signingUp: true,
    infoPage: true,
    complianceManagement: true,
    accountsPage: true,
    accountsPageUploads: true,
    journalsPage: true,
    tBalance: true,
    bankBalances: true,
    csvDataPage: true,
    invoices: true,
    inventory: true,
    openingBalances: true,
    provisionalTax: true,
    payslips: true,
    financialStatements: true,
    icons: true,
    profilePage: true,
    bankFeeds: true,
    supportTicket: true,
    cipcGuide: true,
    clientPortalGuide: true,
  });

  const toggleSection = (sectionId) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  // Open the guide reached from a feature link or the documentation contents.
  useEffect(() => {
    const openLinkedSection = () => {
      const stateKey = {
        "2": "complianceManagement",
        "3": "accountsPage",
        "9": "invoices",
        "12": "journalsPage",
        "14": "payslips",
        "15": "financialStatements",
        "23": "supportTicket",
        "24": "cipcGuide",
        "25": "clientPortalGuide",
      }[window.location.hash.slice(1)];
      if (stateKey) setCollapsedSections((prev) => ({ ...prev, [stateKey]: false }));
    };
    openLinkedSection();
    window.addEventListener("hashchange", openLinkedSection);
    return () => window.removeEventListener("hashchange", openLinkedSection);
  }, []);

  useEffect(() => {
    let stop = false;
    if (stop) return;
    setstylingOnClickUsageInfo("MediumBlue");
    return () => {
      stop = true;
    };
  }, []);
  const [loading, setLoading] = useState(false);
  const [imagesArray, setImagesArray] = useState([]);
  useEffect(() => {
    const storage = getStorage();
    setLoading(true);

    async function loadImages() {
      try {
        const res = await listAll(ref(storage, `/DocumentationImages/`));

        const urlPromises = res.items.map(async (folderRef) => {
          try {
            const url = await getDownloadURL(folderRef);
            return url;
          } catch (error) {
            console.error("Error loading image:", folderRef.name, error);
            return null;
          }
        });

        const urls = await Promise.all(urlPromises);
        const validUrls = urls.filter((url) => url !== null);
        setImagesArray(validUrls);
        setLoading(false);
      } catch (error) {
        console.error("Error listing images:", error);
        setLoading(false);
      }
    }

    loadImages();
  }, []);
  function DisplayImage(fileName) {
    if (imagesArray.length === 0) {
      return "";
    }
    const matchedImage = imagesArray.find((el) => el.includes(fileName));
    return matchedImage || "";
  }
  //

  function LoadingCheck(el) {
    if (loading || imagesArray.length === 0) {
      return (
        <span
          style={{ margin: 15 }}
          className="spinner-border text-primary"
          role="status"
        ></span>
      );
    } else return el;
  }
  //
  function DownloadCSV(el) {
    ///
    const storage = getStorage();
    getDownloadURL(ref(storage, "SampleCSV/Upload_CSV_To_FilingStack.csv"))
      .then((urlValue) => {
        // console.log(urlValue);
        const url = urlValue;

        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute(
          "download",
          "CSV " + new Date().toLocaleDateString() + ".csv"
        );
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error) => {
        console.log(error);
        // Handle any errors
      });
  }
  return (
    <div
      id="top"
      style={{
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        backgroundColor: darkMode ? "#0f172a" : "#ffffff",
      }}
    >
      <style>
        {`
          @media (max-width: 768px) {
            /* Ensure proper text wrapping on mobile */
            p, li, span, div {
              word-wrap: break-word;
              overflow-wrap: break-word;
              hyphens: auto;
            }
            /* Ensure containers don't force single-word lines */
            .doc-section, .step-card, .feature-highlight {
              min-width: 0;
              width: 100%;
            }
            /* Adjust padding for better readability */
            h1, h2, h3, h4, h5, h6 {
              word-wrap: break-word;
              overflow-wrap: break-word;
            }
          }
        `}
      </style>
      <HomePage stylingOnClickUsageInfo={stylingOnClickUsageInfo} />

      {/* Modern Hero Section */}
      <DocHero darkMode={darkMode} />

      <div
        style={{
          maxWidth: "1000px",
          margin: "20px auto 0",
          padding: "0 20px",
        }}
      >
        <div
          style={{
            background: darkMode
              ? "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)"
              : "linear-gradient(135deg, #eff6ff 0%, #ecfeff 100%)",
            border: `1px solid ${darkMode ? "#334155" : "#bfdbfe"}`,
            borderRadius: "14px",
            padding: "16px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "14px",
            flexWrap: "wrap",
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                fontSize: "1rem",
                fontWeight: "700",
                color: darkMode ? "#e2e8f0" : "#0f172a",
              }}
            >
              FilingStack Manual (PDF)
            </div>
            <div
              style={{
                fontSize: "0.9rem",
                marginTop: "4px",
                color: darkMode ? "#94a3b8" : "#334155",
              }}
            >
              Keep the full manual handy for team onboarding and quick lookup.
            </div>
          </div>
          <a
            href={FILINGSTACK_MANUAL_URL}
            target="_blank"
            rel="noreferrer"
            style={{
              background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
              color: "#ffffff",
              textDecoration: "none",
              fontWeight: "600",
              borderRadius: "999px",
              padding: "10px 16px",
              whiteSpace: "nowrap",
            }}
          >
            Download Manual
          </a>
        </div>
      </div>

      {loading && (
        <div style={{ textAlign: "left", padding: "0.75rem" }}>
          <span
            style={{ margin: "0.5rem" }}
            className="spinner-border text-primary"
            role="status"
          ></span>
        </div>
      )}

      {/* Modern Table of Contents with Search */}
      <DocNav darkMode={darkMode} />

      {/* Documentation Content */}
      <div
        style={{
          backgroundColor: darkMode ? "#1e293b" : "white",
          padding: "60px 20px",
          minWidth: 0,
          width: "100%",
        }}
      >
        <div style={{ maxWidth: "1000px", margin: "0 auto", minWidth: 0 }}>
          {/* Section 1: Signing up */}
          <DocSection
            id="1"
            title="Signing up"
            number="1"
            darkMode={darkMode}
            isCollapsed={collapsedSections.signingUp}
            onToggle={() => toggleSection("signingUp")}
          >
            <p style={{ marginBottom: "20px" }}>
              To use this application, clients must sign up for an account with
              FilingStack. Clients can also sign up with a Google account.
              Thereafter clients can login with their email and password on
              subsequent visits.
            </p>
            <div
              style={{
                backgroundColor: darkMode ? "#064e3b" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#065f46" : "#bbf7d0"}`,
                marginBottom: "20px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#6ee7b7" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                💡 Pro Tips:
              </h4>
              <ul
                style={{
                  color: darkMode ? "#86efac" : "#047857",
                  paddingLeft: "20px",
                }}
              >
                <li>
                  Users can add additional users on their profiles using the Add
                  User option in the Navigation menu
                </li>
                <li>
                  If users forget their password, click on Reset Password on the
                  login page for recovery instructions
                </li>
              </ul>
            </div>
          </DocSection>

          {/* Section 2: Compliance Management */}
          <DocSection
            id="2"
            title="Compliance Management"
            number="2"
            darkMode={darkMode}
            isCollapsed={collapsedSections.complianceManagement}
            onToggle={() => toggleSection("complianceManagement")}
          >
            <p style={{ marginBottom: "20px" }}>
              The compliance management system helps track and manage VAT,
              Payroll, CIPC, and Provisional Tax obligations for your client
              companies.
            </p>

            <RecentWorkflowGuide guideKey="cipc" darkMode={darkMode} />
            <p><a href="#24">Read the complete CIPC Automation guide: setup, fees, approvals, emails and troubleshooting.</a></p>

            <FeatureHighlight
              title="Compliance Features"
              darkMode={darkMode}
              features={[
                "💰 VAT Registration Tracking - Automatic monthly VAT return tasks",
                "👥 Payroll Services - Monthly PAYE & UIF submission reminders",
                "📋 CIPC Annual Returns - Company registration compliance tracking",
                "🧾 Provisional Tax - Quarterly IRP6 payment tracking",
                "👤 Team Assignment - Assign compliance work to specific team members",
                "🔍 Smart Filtering - Filter companies by compliance type on dashboard",
              ]}
            />

            <StepCard
              number="1"
              title="Adding Compliance for New Companies"
              darkMode={darkMode}
            >
              <p style={{ marginBottom: "12px" }}>
                When adding a new company via the <strong>Add Entities</strong>{" "}
                page:
              </p>
              <ol style={{ paddingLeft: "20px", margin: "12px 0" }}>
                <li style={{ marginBottom: "8px" }}>
                  Fill in the standard company details (name, registration, year
                  end, etc.)
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Scroll to the <strong>"✓ Compliance Requirements"</strong>{" "}
                  section
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Check the boxes for applicable compliance obligations:
                  <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
                    <li>💰 VAT Registered (for VAT-registered companies)</li>
                    <li>👥 Payroll Services (if managing employee payroll)</li>
                    <li>
                      📋 CIPC Returns (for companies requiring annual filings)
                    </li>
                    <li>
                      🧾 Provisional Tax (for companies paying provisional tax)
                    </li>
                  </ul>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Select a team member from the <strong>"Assigned To"</strong>{" "}
                  dropdown to assign compliance work
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Save the company - compliance tasks will be automatically
                  created
                </li>
              </ol>
            </StepCard>

            <StepCard
              number="2"
              title="Editing Compliance for Existing Companies"
              darkMode={darkMode}
            >
              <p style={{ marginBottom: "12px" }}>
                To update compliance settings for an existing company:
              </p>
              <ol style={{ paddingLeft: "20px", margin: "12px 0" }}>
                <li style={{ marginBottom: "8px" }}>
                  Go to the <strong>My Entities</strong> page
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Click on a company to view its details
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Click the <strong>Settings</strong> button
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Scroll to the <strong>"✓ Compliance Requirements"</strong>{" "}
                  section
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Update the checkboxes and team assignment as needed
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Click <strong>Save Updates</strong> - new tasks will be
                  created for newly enabled compliance features
                </li>
              </ol>
            </StepCard>

            <StepCard
              number="3"
              title="Viewing Compliance Badges"
              darkMode={darkMode}
            >
              <p style={{ marginBottom: "12px" }}>
                Compliance badges appear on the <strong>My Entities</strong>{" "}
                page showing which companies have specific compliance
                obligations:
              </p>
              <ul style={{ paddingLeft: "20px", margin: "12px 0" }}>
                <li style={{ marginBottom: "8px" }}>
                  <strong>💰 VAT</strong> - Blue badge for VAT-registered
                  companies
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>👥 Payroll</strong> - Green badge for companies with
                  payroll services
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>📋 CIPC</strong> - Purple badge for companies with
                  CIPC obligations
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>🧾 Prov Tax</strong> - Orange badge for provisional
                  tax companies
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>👤 Assigned email</strong> - Pink badge showing team
                  member assignment (hover to see full email)
                </li>
              </ul>
            </StepCard>

            <StepCard
              number="4"
              title="Filtering Companies by Compliance"
              darkMode={darkMode}
            >
              <p style={{ marginBottom: "12px" }}>
                Use the filter buttons on the <strong>My Entities</strong> page
                to quickly find companies:
              </p>
              <ul style={{ paddingLeft: "20px", margin: "12px 0" }}>
                <li style={{ marginBottom: "8px" }}>
                  <strong>All Companies</strong> - Show all entities (default
                  view)
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>💰 VAT Only</strong> - Show only VAT-registered
                  companies
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>👥 Payroll Only</strong> - Show only companies with
                  payroll
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>📋 CIPC Only</strong> - Show only companies requiring
                  CIPC filings
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>🧾 Prov Tax Only</strong> - Show only provisional tax
                  companies
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>👤 Assigned Only</strong> - Show only companies with
                  assigned team members
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Click <strong>✕ Clear</strong> to reset the filter
                </li>
              </ul>
            </StepCard>

            <StepCard
              number="5"
              title="Automatic Task Creation"
              darkMode={darkMode}
            >
              <p style={{ marginBottom: "12px" }}>
                When compliance features are enabled, tasks are automatically
                created with appropriate due dates:
              </p>
              <ul style={{ paddingLeft: "20px", margin: "12px 0" }}>
                <li style={{ marginBottom: "8px" }}>
                  <strong>VAT Returns</strong> - Due on the last business day of
                  the following month (monthly)
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>Payroll Returns</strong> - Due on the 7th of the
                  following month (monthly)
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>CIPC Filings</strong> - Review the company anniversary,
                  selected filing years and displayed deadline in CIPC Automation.
                  Generic task dates are planning reminders.
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <strong>Provisional Tax</strong> - Due 3 months ahead
                  (quarterly IRP6 payments)
                </li>
              </ul>
              <p style={{ marginTop: "16px" }}>
                Tasks are automatically assigned to the team member specified in
                the compliance settings.
              </p>
            </StepCard>

            <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1e40af" : "#93c5fd"}`,
                marginTop: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                💡 Pro Tip
              </h4>
              <p style={{ color: darkMode ? "#bfdbfe" : "#1e40af", margin: 0 }}>
                Compliance settings are synced with the Tax Settings page.
                Updates made in either location will reflect across the system,
                ensuring consistency in your compliance tracking.
              </p>
            </div>
          </DocSection>

          {/* Section 3: My Entities page */}
          <DocSection
            id="entities"
            title="My Entities page"
            number="3"
            darkMode={darkMode}
            isCollapsed={collapsedSections.infoPage}
            onToggle={() => toggleSection("infoPage")}
          >
            <p style={{ marginBottom: "20px" }}>
              After logging in, users are redirected to the My Entities page.
            </p>

            <div
              style={{
                backgroundColor: darkMode ? "#78350f" : "#fef3c7",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#92400e" : "#fcd34d"}`,
                marginBottom: "20px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fcd34d" : "#92400e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🏢 Demo Company
              </h4>
              <p style={{ color: darkMode ? "#fde68a" : "#a16207", margin: 0 }}>
                Initially when a client signs up and logs in for the first time,
                the only company that would reflect on the My Entities page is a
                demo company that is added automatically added for new clients.
              </p>
            </div>

            <p style={{ marginBottom: "20px" }}>
              Clients can add additional businesses via the Add Entities link
              found on the My Entities page.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Add Company Visual"
                  src={DisplayImage("addCompany.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            {/* <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1e40af" : "#93c5fd"}`,
                marginBottom: "20px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                💳 Payment Requirements
              </h4>
              <p style={{ color: darkMode ? "#bfdbfe" : "#1d4ed8", margin: 0 }}>
                Prior to adding additional companies, a client must update the
                default limits on their FilingStack profile. This is done by
                clicking on the Payments link found on the My Entities page. Once
                redirected to the Payments page a client must enter the amount
                of usage they'd like to add, and make payment via Payfast.
              </p>
            </div> */}

            <p style={{ marginBottom: "20px" }}>
              FilingStack offers a subscription based month to month recurring
              billing option, where billing takes place per month. Clients can
              cancel their subscription at any time, by clicking on the Cancel
              subscription button on the Payments page.
            </p>

            <div style={{ margin: "24px 0" }}>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://youtu.be/wBploRRT5uo"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "#ddf5d1ff",
                  color: "white",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  textDecoration: "none",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                }}
              >
                📹 Watch Tutorial Video
              </a>
            </div>

            <p style={{ marginBottom: "20px" }}>
              After adding new companies, a new company can be selected by
              clicking on the company's name from the list of companies on the
              My Entities page. The client would then be redirected to the
              Dashboard page. If no company is selected, all other pages will
              redirect to the My Entities page.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Add User Visual"
                  src={DisplayImage("addUser.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>
          </DocSection>

          {/* Section 3: Accounts page */}
          <DocSection
            id="3"
            title="Accounts & Transactions"
            emoji="💼"
            darkMode={darkMode}
            isCollapsed={collapsedSections.accountsPage}
            onToggle={() => toggleSection("accountsPage")}
          >
            <p style={{ marginBottom: "20px" }}>
              The Accounts page lets you upload bank statements and allocate
              transactions to the correct accounts.
            </p>

            <RecentWorkflowGuide guideKey="allocation" darkMode={darkMode} />

            <div
              style={{
                backgroundColor: darkMode ? "#78350f" : "#fef3c7",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#92400e" : "#fcd34d"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fcd34d" : "#92400e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🏦 First Step: Add a Bank Account
              </h4>
              <p style={{ color: darkMode ? "#fde68a" : "#a16207", margin: 0 }}>
                After adding a new company, start by clicking{" "}
                <strong>Add Bank Account</strong> on the Accounts page.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Add Bank Account Visual"
                  src={DisplayImage("AddBankAccount.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <p style={{ marginBottom: "20px" }}>
              Once you've added a bank account, upload transactions and allocate
              each one to the appropriate account.
            </p>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginTop: "24px",
                marginBottom: "16px",
              }}
            >
              ⚡ Smart Allocations & Fast-Triage
            </h3>
            <p style={{ marginBottom: "16px" }}>
              To speed up data tagging, the allocation dropdown includes several powerful tools:
            </p>
            <ul
              style={{
                paddingLeft: "20px",
                marginBottom: "24px",
                lineHeight: "1.6",
                color: darkMode ? "#cbd5e1" : "#334155",
              }}
            >
              <li>
                <strong>Enter-to-apply:</strong> Type part of an account name right in the table row's dropdown and press Enter. It will immediately assign the top filtered result to save you a click.
              </li>
              <li>
                <strong>Auto-match (Rule Memory):</strong> Check the "Auto-match" box inside the dropdown. When you allocate a transaction (e.g. "UBER" to "Travel"), the system will instantly scan the entire table and automatically assign "Travel" to <em>every other unassigned "UBER" transaction</em>. 
              </li>
              <li>
                <strong>Quick Apply Button:</strong> Once you make an allocation, the next dropdown you open will feature a 'Quick Apply (↩)' shortcut at the top showing your last used account. Click it to instantly apply the same account again.
              </li>
            </ul>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📊 Managing Account Groups
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Additional Account groups can be added via the Add button on the
              Account group column, on the Accounts page.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Add Account Visual"
                  src={DisplayImage("AddAccount.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <p style={{ marginBottom: "20px" }}>
              If an account needs to be re-allocated, transactions can be batch
              edited to the account.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Edit All Visual"
                  src={DisplayImage("editAll.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <div
              style={{
                backgroundColor: "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #bbf7d0",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ⚡ Automatic Report Generation
              </h4>
              <p style={{ color: "#047857", margin: 0 }}>
                FilingStack software would thereafter automatically generate a
                ledger, trial balance, and other financial reports.
              </p>
            </div>

            {/* <div
                style={{
                  backgroundColor: "#fef2f2",
                  padding: "20px",
                  borderRadius: "12px",
                  border: "1px solid #fecaca",
                  marginBottom: "24px",
                }}
              >
                <h4
                  style={{
                    color: "#991b1b",
                    marginBottom: "12px",
                    fontSize: "1.1rem",
                  }}
                >
                  ⚠️ Important: Financial Year Compliance
                </h4>
                <p style={{ color: "#dc2626", marginBottom: "12px" }}>
                  It is important that all transactions uploaded are within the
                  financial year for the company selected. For example: if the
                  company selected has a financial year 1 March 2024 to 28
                  February 2025, all transactions uploaded must be within that
                  period.
                </p>
                <p style={{ color: "#dc2626", margin: 0 }}>
                  Dates with red text indicate out of year transactions. To add
                  different years for the same company, the 'Add Year' link on
                  the Accounts page must be used.
                </p>
              </div> */}

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Add Year Visual"
                  src={DisplayImage("addYear.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              ✏️ Manual Transaction Entry
            </h3>
            <p style={{ marginBottom: "20px" }}>
              The "Add Year" link adds additional years for easier financials
              date filtering and notes storage. The first row on the accounts
              page can be used to enter new transaction data, if there are few
              transactions.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Entry Row Visual"
                  src={DisplayImage("entryRow.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <p style={{ marginBottom: "24px" }}>
              After an account group is selected, the Save button appears on the
              first row. The account name and account group details must be
              entered, and a bank account must be selected for the entry to
              save.
            </p>

            {/* Auto Allocation Features */}
            <div
              style={{
                backgroundColor: "#dbeafe",
                padding: "24px",
                borderRadius: "12px",
                border: "1px solid #93c5fd",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#1e40af",
                  marginBottom: "16px",
                  fontSize: "1.2rem",
                }}
              >
                🤖 Smart Auto-Allocation Buttons
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    backgroundColor: darkMode ? "#111827" : "white",
                    padding: "16px",
                    borderRadius: "8px",
                    border: "1px solid #bfdbfe",
                  }}
                >
                  <h5
                    style={{
                      color: "#1d4ed8",
                      marginBottom: "8px",
                      fontSize: "1rem",
                    }}
                  >
                    📋 Auto Allocate by Prior Allocations
                  </h5>
                  <p
                    style={{
                      color: "#3730a3",
                      margin: 0,
                      fontSize: "0.95rem",
                    }}
                  >
                    Automatically allocate unallocated transactions (No
                    Account), based on how similar transactions were allocated
                    previously.
                  </p>
                </div>
                <div
                  style={{
                    backgroundColor: darkMode ? "#111827" : "white",
                    padding: "16px",
                    borderRadius: "8px",
                    border: "1px solid #bfdbfe",
                  }}
                >
                  <h5
                    style={{
                      color: "#1d4ed8",
                      marginBottom: "8px",
                      fontSize: "1rem",
                    }}
                  >
                    🧠 AI Auto Allocate
                  </h5>
                  <p
                    style={{
                      color: "#3730a3",
                      margin: 0,
                      fontSize: "0.95rem",
                    }}
                  >
                    Automatically allocate unallocated transactions using
                    Artificial Intelligence for smarter transaction
                    categorization.
                  </p>
                </div>
              </div>
            </div>

            <div style={{ margin: "24px 0" }}>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://youtu.be/ZLYIzV4JeV4"
                className="watch-button"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "#1e40af",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                  boxShadow: "0 2px 8px rgba(30, 64, 175, 0.3)",
                }}
              >
                📹 Watch: How to Add Transactions
              </a>
            </div>
          </DocSection>

          {/* Section 4: Uploading CSV files */}
          <DocSection
            id="4"
            title="Upload CSV Bank Statements"
            emoji="📊"
            darkMode={darkMode}
            isCollapsed={collapsedSections.accountsPageUploads}
            onToggle={() => toggleSection("accountsPageUploads")}
          >
            <div
              style={{
                backgroundColor: darkMode ? "#065f46" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #bbf7d0",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#bbf7d0" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📁 Upload Process
              </h4>
              <p style={{ color: darkMode ? "#d1fae5" : "#047857", margin: 0 }}>
                The Choose File button is used to select a CSV file for upload,
                and the Upload file button is used to upload a selected CSV file
                and is enabled after a file is selected.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Upload File Visual"
                  src={DisplayImage("UploadFile.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <h3
              style={{
                color: darkMode ? "#f3f4f6" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📊 CSV File Format Requirements
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Bank statements must be uploaded in the CSV format. Below is an
              image of how the CSV file columns should look. To save an Excel
              file as CSV, click 'Save as Comma delimited' when saving the file.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="CSV File Format"
                  src={DisplayImage("csvFile.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <div style={{ margin: "24px 0" }}>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://youtu.be/zQf7mQkCeUE"
                className="watch-button"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "#1e40af",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                  boxShadow: "0 2px 8px rgba(30, 64, 175, 0.3)",
                }}
              >
                📹 Watch: CSV Upload Tutorial
              </a>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              💾 Getting Bank Statements in CSV Format
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Clients can download their bank statements in the CSV format from
              their banking website/app. If a bank statement is not available in
              the CSV format, the statement can be downloaded in the PDF format
              and exported to excel using{" "}
              <a
                style={{
                  fontWeight: "bold",
                  color: "#3b82f6",
                  textDecoration: "none",
                  borderBottom: "2px solid #3b82f6",
                }}
                href="./ExtractData"
                target="_blank"
                rel="noreferrer"
              >
                AI Extract
              </a>
              .
            </p>

            <p style={{ marginBottom: "20px" }}>
              This is available on the{" "}
              <a
                style={{
                  fontWeight: "bold",
                  color: "#7c3aed",
                  textDecoration: "none",
                  borderBottom: "2px solid #7c3aed",
                }}
                href="./ExtractData"
                target="_blank"
                rel="noreferrer"
              >
                Convert PDF
              </a>{" "}
              page.
            </p>

            <div
              style={{
                display: "flex",
                gap: "16px",
                margin: "24px 0",
                flexWrap: "wrap",
                justifyContent: "left",
              }}
            >
              {LoadingCheck(
                <img
                  alt="Convert PDF Visual"
                  src={DisplayImage("convertPDF.png")}
                  style={{
                    maxWidth: "45%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
              {/* {LoadingCheck(
                  <img
                    alt="Convert to CSV Visual"
                    src={DisplayImage("convertToCSV.png")}
                    style={{
                      maxWidth: "45%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )} */}
            </div>

            <div
              style={{
                backgroundColor: "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #93c5fd",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🛠️ Compatible Software Tools
              </h4>
              <p style={{ color: "#1d4ed8", margin: 0 }}>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.microsoft.com/en-us/microsoft-365/excel"
                  style={{ color: "#1d4ed8", fontWeight: "600" }}
                >
                  Microsoft Excel
                </a>
                ,{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.google.com/sheets/about/"
                  style={{ color: "#1d4ed8", fontWeight: "600" }}
                >
                  Google Sheets
                </a>
                , or{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.libreoffice.org/download/download-libreoffice/"
                  style={{ color: "#1d4ed8", fontWeight: "600" }}
                >
                  LibreOffice
                </a>{" "}
                can be used to edit the CSV file, to upload onto FilingStack
                Accounting software.
              </p>
            </div>

            <div
              style={{
                backgroundColor: "#fef3c7",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #fcd34d",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#92400e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📋 Reccommended CSV Format
              </h4>
              <ul
                style={{
                  color: "#a16207",
                  paddingLeft: "20px",
                  margin: 0,
                }}
              >
                <li>
                  <strong>3 columns required:</strong> Date, Description, Amount
                </li>
                <li>
                  <strong>Date format:</strong> YYYY/MM/DD (e.g., 2023/01/28)
                  (optional)
                </li>
                <li>
                  <strong>Description:</strong> Bank statement transaction
                  description
                </li>
                <li>
                  <strong>Amount:</strong> Transaction amount (positive for
                  receipts, negative for payments)
                </li>
              </ul>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="CSV Format Example"
                  src={DisplayImage("csvFile.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              <button
                style={{
                  backgroundColor: "#059669",
                  color: "white",
                  border: "none",
                  padding: "14px 28px",
                  borderRadius: "8px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(5, 150, 105, 0.3)",
                }}
                onClick={DownloadCSV}
              >
                📥 Download Sample CSV File
              </button>
              <p
                style={{
                  fontSize: "0.9rem",
                  color: "#64748b",
                  marginTop: "8px",
                }}
              >
                Use this template format for your bank statement uploads
              </p>
            </div>

            <div
              style={{
                backgroundColor: "#fef2f2",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #fecaca",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#991b1b",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ⚠️ Important: Transaction Amount Format
              </h4>
              <ul
                style={{
                  color: "#dc2626",
                  paddingLeft: "20px",
                  margin: 0,
                }}
              >
                <li>
                  <strong>Receipts/Income:</strong> Positive numbers (e.g.,
                  5000)
                </li>
                <li>
                  <strong>Payments/Expenses:</strong> Negative numbers (e.g.,
                  -5000)
                </li>
              </ul>
            </div>

            <div
              style={{
                backgroundColor: "#f0f9ff",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #bae6fd",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#0c4a6e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                💡 Pro Tip: Account Group Import
              </h4>
              <p style={{ color: "#0369a1", margin: 0 }}>
                While there is an Account group option when importing a CSV
                file, it should only be used to import CSV Account groups
                exported from the FilingStack accounts page, as the Account
                groups must match the accounts stored on FilingStack. If
                incorrect account group data is added, the financial statements
                may not balance and inaccurate data may result.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              <a
                style={{
                  fontWeight: "bold",
                  color: "#dc2626",
                  textDecoration: "none",
                  borderBottom: "2px solid #dc2626",
                }}
                href="./Support"
                target="_blank"
                rel="noreferrer"
              >
                Need Help? Contact Support →
              </a>
            </div>
          </DocSection>

          {/* Section 5: Adding a new year */}
          <DocSection
            id="5"
            title="Add Financial Years"
            emoji="📅"
            darkMode={darkMode}
            isCollapsed={collapsedSections.journalsPage}
            onToggle={() => toggleSection("journalsPage")}
          >
            <div
              style={{
                backgroundColor: darkMode ? "#7f1d1d" : "#fef2f2",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#991b1b" : "#fecaca"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fca5a5" : "#991b1b",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📅 Adding New Financial Years
              </h4>
              <p style={{ color: darkMode ? "#fecaca" : "#dc2626", margin: 0 }}>
                Use the <strong>Add Year</strong> option on the Accounts page to
                create a new financial year for your company.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Add Year Visual"
                  src={DisplayImage("addYear.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              ⚙️ Account Page Options
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Other options on the Account page include Account Group which is
              used to allocate transactions. There are also options for VAT
              Type.
            </p>

            <div
              style={{
                backgroundColor: "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #93c5fd",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                💡 VAT Column Usage
              </h4>
              <p style={{ color: "#1d4ed8", margin: 0 }}>
                The VAT column is only open for editing when manual VAT is
                selected.
              </p>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              🔗 Link Column Features
            </h3>
            <p style={{ marginBottom: "20px" }}>
              The Link column has options to create a rule that tells the
              software to allocate all future transactions uploaded that have
              the same name, to the same account. It also has options to
              reconcile and match an invoice to the transaction. This will allow
              the software to track which Invoices have been paid and which
              Invoices have outstanding balances receivable.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Link Options Visual"
                  src={DisplayImage("link.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>
          </DocSection>

          {/* Section 6: Simultaneous edits */}
          <DocSection
            id="6"
            title="Batch Edit Transactions"
            emoji="✏️"
            darkMode={darkMode}
            isCollapsed={collapsedSections.openingBalances}
            onToggle={() => toggleSection("openingBalances")}
          >
            <div
              style={{
                backgroundColor: "#f3e8ff",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #c4b5fd",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#7c2d12",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ✏️ Edit All Feature
              </h4>
              <p style={{ color: "#7c3aed", margin: 0 }}>
                The "Edit All" option allows for editing large transactions
                together. It takes effect after clicking the Save button.
              </p>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📊 Eligible Columns
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Columns eligible for Edit all options are the Date, Account Group
              and VAT Type columns. They are underlined when Edit All is
              selected.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Edit All Visual"
                  src={DisplayImage("editAll.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <div
              style={{
                backgroundColor: "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #93c5fd",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                💡 Save Button Indicators
              </h4>
              <p style={{ color: "#1d4ed8", margin: 0 }}>
                The Save button is green when there is no data to be saved, and
                blue when there is data not yet saved.
              </p>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              🔧 Additional Options
            </h3>
            <p style={{ marginBottom: "20px" }}>
              The Enable Delete option enables the delete functionality, and
              also closes the delete option on the 2nd click. It is recommended
              that the delete button is not enabled in general use.
            </p>

            <p style={{ marginBottom: "20px" }}>
              The Search option allows users to filter transaction data.
            </p>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              💰 Opening Balance Guidelines
            </h3>
            <p style={{ marginBottom: "20px" }}>
              The Opening balance column must have payments as negative numbers
              with a negative sign, and receipts as positive numbers.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Opening Balance Visual"
                  src={DisplayImage("openingBalance.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>
          </DocSection>

          {/* Section 7: Pagination */}
          <DocSection
            id="7"
            title="Transaction Pagination"
            emoji="📊"
            darkMode={darkMode}
            isCollapsed={collapsedSections.provisionalTax}
            onToggle={() => toggleSection("provisionalTax")}
          >
            <div
              style={{
                backgroundColor: "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #a7f3d0",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📄 Page Navigation
              </h4>
              <p style={{ color: "#059669", margin: 0 }}>
                The Accounts page supports pagination, and the previous and next
                buttons are enabled once there are more than 10 pages.
              </p>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📊 Historical Data
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Transactions marked as Historical are allocated to the historical
              tab.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Historical Tab Visual"
                  src={DisplayImage("historical.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>
          </DocSection>

          {/* Section 8: Trial balance & Ledger */}
          <DocSection
            id="8"
            title="Trial balance & Ledger"
            emoji="📊"
            darkMode={darkMode}
            isCollapsed={collapsedSections.tBalance}
            onToggle={() => toggleSection("tBalance")}
          >
            {/* New Date Filter Feature */}
            <FeatureHighlight
              title="📅 Date Range Filtering"
              badge="NEW"
              darkMode={darkMode}
              features={[
                "Filter ledger entries by custom date ranges",
                "Quick access to preset periods (This Month, Last Month, This Quarter, This Year)",
                "Year-by-year dropdown for historical data",
                "Combined date and year filtering for precise control",
                "Instant ledger updates when filters change",
              ]}
            />

            {/* Step-by-step Guide for Using Date Filtering */}
            <div style={{ marginTop: "32px" }}>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  marginBottom: "24px",
                  color: darkMode ? "#e2e8f0" : "#1e293b",
                }}
              >
                How to Use Date Filtering
              </h3>

              <StepCard
                number={1}
                title="Navigate to Ledger"
                darkMode={darkMode}
              >
                Click on "Ledger" in the main navigation menu to access the
                account ledger page. The DateRangePicker will be visible at the
                top of the page.
              </StepCard>

              <StepCard
                number={2}
                title="Choose a Preset Period"
                darkMode={darkMode}
              >
                <p style={{ marginBottom: "12px" }}>
                  Select from quick presets for common periods:
                </p>
                <ul style={{ marginLeft: "20px", lineHeight: "1.8" }}>
                  <li>
                    📅 <strong>This Month</strong> - Current month's
                    transactions
                  </li>
                  <li>
                    ⏮️ <strong>Last Month</strong> - Previous month's data
                  </li>
                  <li>
                    📊 <strong>This Quarter</strong> - Current quarter view
                  </li>
                  <li>
                    📆 <strong>This Year</strong> - Full current year
                  </li>
                  <li>
                    📋 <strong>Last Year</strong> - Previous year's data
                  </li>
                  <li>
                    ♾️ <strong>All Time</strong> - Every transaction
                  </li>
                </ul>
              </StepCard>

              <StepCard
                number={3}
                title="Or Select Custom Dates"
                darkMode={darkMode}
              >
                For specific analysis, click on the start and end date fields to
                choose any custom date range. This is perfect for analyzing
                specific weeks, months, or fiscal periods.
              </StepCard>

              <StepCard
                number={4}
                title="Use Year Dropdown"
                darkMode={darkMode}
              >
                The year dropdown lets you quickly switch between available
                business years while maintaining your selected date range
                pattern.
              </StepCard>

              <StepCard
                number={5}
                title="View & Export Results"
                darkMode={darkMode}
              >
                The ledger automatically updates to show only transactions
                within your selected date range. Opening balances are calculated
                correctly based on all prior transactions. Use "Export to CSV"
                to download filtered data.
              </StepCard>
            </div>

            {/* Pro Tips Section */}
            <div
              style={{
                marginTop: "32px",
                padding: "20px",
                backgroundColor: darkMode
                  ? "rgba(59, 130, 246, 0.1)"
                  : "rgba(59, 130, 246, 0.05)",
                borderLeft: "4px solid #3b82f6",
                borderRadius: "8px",
              }}
            >
              <h4
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  marginBottom: "12px",
                  color: darkMode ? "#60a5fa" : "#2563eb",
                }}
              >
                💡 Pro Tips
              </h4>
              <ul style={{ marginLeft: "20px", lineHeight: "1.8" }}>
                <li>
                  Combine date filtering with account group selection for
                  precise analysis
                </li>
                <li>
                  The search box works with filtered results - double filter
                  power!
                </li>
                <li>
                  Opening balances reflect ALL transactions before your start
                  date
                </li>
                <li>
                  CSV exports include only filtered transactions with correct
                  opening balances
                </li>
              </ul>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#7c2d12" : "#fff7ed",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#9a3412" : "#fed7aa"}`,
                marginBottom: "24px",
                marginTop: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fed7aa" : "#9a3412",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🔄 Ledger Navigation
              </h4>
              <p style={{ color: darkMode ? "#fdba74" : "#ea580c", margin: 0 }}>
                While links are provided for trial balance line item accounts to
                view them in the ledger, links from the ledger to the Accounts
                and journal page currently do not show accounts that are not
                within the selected year.
              </p>
            </div>

            <h3
              style={{
                color: darkMode ? "#e2e8f0" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📊 Year Selection Requirements
            </h3>
            <p style={{ marginBottom: "20px" }}>
              When clicking on a ledger account , the ledger will reroute to
              that entry.
            </p>

            <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1e40af" : "#93c5fd"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📥 CSV Export Process
              </h4>
              <p style={{ color: darkMode ? "#bfdbfe" : "#1d4ed8", margin: 0 }}>
                To export the ledger to a CSV file, click the Prepare CSV
                button, and thereafter click on Download CSV to export the
                ledger data to a CSV file.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Ledger Visual"
                  src={DisplayImage("ledger.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>
          </DocSection>

          {/* Section 9: Invoices */}
          <DocSection
            id="9"
            title="Invoices & Billing"
            emoji="💼"
            darkMode={darkMode}
            isCollapsed={collapsedSections.invoices}
            onToggle={() => toggleSection("invoices")}
          >
            <div id="invoiceID" style={{ scrollMarginTop: "100px" }} />
            <RecentWorkflowGuide guideKey="statements" darkMode={darkMode} />
            <div
              style={{
                backgroundColor: darkMode ? "#164e63" : "#f0f9ff",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#0e7490" : "#7dd3fc"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#67e8f9" : "#0c4a6e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📄 Create & Manage Invoices
              </h4>
              <p style={{ color: darkMode ? "#22d3ee" : "#0891b2", margin: 0 }}>
                Use the <strong>Add Invoice</strong> page to create new
                invoices, then edit them on the <strong>Invoices Added</strong>{" "}
                page to add products, services, and additional details.
              </p>
            </div>

            <div id="sars-e-invoicing" style={{ scrollMarginTop: "100px" }} />
            <h3
              style={{
                color: darkMode ? "#e2e8f0" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              SARS e-invoice-ready workflow
            </h3>
            <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
              FilingStack now separates invoice preparation from formal
              issuance. This protects the tax record from accidental changes
              and prepares a structured invoice for future electronic
              submission integrations.
            </p>

            <StepCard
              number="1"
              title="Prepare and save the draft"
              darkMode={darkMode}
            >
              New and imported invoices remain in <strong>Draft</strong>. Add
              the supplier legal name, address and VAT number (when VAT is
              enabled), the customer details, invoice and supply dates, and
              complete line-item descriptions, quantities and VAT treatments.
              Supplier invoices received from vendors are stored as received
              documents and are not issued by FilingStack.
            </StepCard>

            <StepCard
              number="2"
              title="Resolve validation issues"
              darkMode={darkMode}
            >
              On <strong>Invoices Added</strong>, select the invoice and review
              its status panel. FilingStack lists missing or invalid fields.
              The invoice will show <strong>Draft - Ready to issue</strong> once
              the required information passes validation. Among other checks,
              VAT numbers must contain 10 digits and begin with 4, the issue
              date must be on or within 21 days after the supply date, and a
              full tax invoice requires the recipient address. FilingStack
              treats an invoice of R5,000 or more, or any invoice containing a
              zero-rated line, as a full tax invoice for validation.
            </StepCard>

            <StepCard
              number="3"
              title="Issue the invoice"
              darkMode={darkMode}
            >
              Select <strong>Issue Invoice</strong> and confirm the action. The
              server performs a final validation, assigns the authoritative
              sequential invoice number and stores an immutable structured
              snapshot of the issued document.
            </StepCard>

            <StepCard
              number="4"
              title="Deliver and retain the record"
              darkMode={darkMode}
            >
              After issuance, generate the PDF or email it to the customer as
              usual. Use <strong>Download Structured JSON</strong> to retain or
              inspect the machine-readable version of the issued invoice.
              Payment status may still be updated without changing the issued
              tax document.
            </StepCard>

            <FeatureHighlight
              icon="VAT"
              title="Choose the correct VAT treatment"
              description="The VAT classification forms part of the structured tax record. Select the treatment that matches the supply instead of using a generic no-tax option."
              badge="Important"
              darkMode={darkMode}
              features={[
                {
                  title: "Standard rate",
                  description:
                    "Use the current 15% rate for ordinary taxable supplies. Use the historical 14% option only when it genuinely applies to the transaction date.",
                },
                {
                  title: "Zero-rated",
                  description:
                    "Use for taxable supplies charged at 0%. This is different from an exempt supply.",
                },
                {
                  title: "Exempt",
                  description:
                    "Use where the supply is exempt from VAT under the applicable rules.",
                },
                {
                  title: "Out of scope or non-VAT vendor",
                  description:
                    "Use the matching classification where the transaction falls outside VAT or the supplier is not VAT registered.",
                },
              ]}
            />

            <div
              style={{
                backgroundColor: darkMode ? "#422006" : "#fffbeb",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#a16207" : "#fcd34d"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fde68a" : "#92400e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                Current SARS integration boundary
              </h4>
              <p
                style={{
                  color: darkMode ? "#fef3c7" : "#92400e",
                  marginBottom: "12px",
                }}
              >
                <strong>Issue Invoice does not submit to SARS.</strong> It
                creates a controlled, e-invoice-ready record and queues the
                structured data for a future approved delivery connector. PDF
                and email remain the current customer delivery methods.
              </p>
              <p style={{ color: darkMode ? "#fef3c7" : "#92400e", margin: 0 }}>
                FilingStack validation assists with record completeness, but it
                does not replace tax advice. The business remains responsible
                for applying the correct VAT treatment and retaining supporting
                documents.
              </p>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#172554" : "#eff6ff",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1d4ed8" : "#bfdbfe"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#bfdbfe" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                Corrections after issuance
              </h4>
              <p style={{ color: darkMode ? "#dbeafe" : "#1d4ed8", margin: 0 }}>
                Issued invoice numbers, dates, tax fields and line items are
                locked, and an issued invoice cannot be deleted. To correct it,
                choose <strong>Create Credit Note</strong> or
                <strong> Create Debit Note</strong>, record the reason and
                original-document reference, review the new draft, and issue it
                through the same validation process.
              </p>
              <p
                style={{
                  color: darkMode ? "#dbeafe" : "#1d4ed8",
                  margin: "12px 0 0",
                }}
              >
                Historical invoices marked as issued before this workflow are
                shown as <strong>Legacy issued</strong>. Their original numbers
                are retained, but they do not claim to have the immutable
                structured snapshot created by the new issuance process.
              </p>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#7f1d1d" : "#fef2f2",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#991b1b" : "#fecaca"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fca5a5" : "#991b1b",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                Invoice Journal Entries
              </h4>
              <p style={{ color: darkMode ? "#fca5a5" : "#dc2626", margin: 0 }}>
                Issuing an invoice does not automatically post an accounting
                journal. Use <strong>Post Journal Entry</strong> on the invoice,
                review the debit and credit accounts, and then confirm the
                posting. When the customer pays, allocate the transaction to
                Trade Receivables on the Accounts page.
              </p>
            </div>

            <h3
              style={{
                color: darkMode ? "#e2e8f0" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              🛍️ Products & Services
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Save products or services on the{" "}
              <strong>Products and Services</strong> page to quickly add them to
              invoices. Use the <strong>Add Business</strong> page to save
              customer or supplier details for invoices and quotes.
            </p>

            <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1e40af" : "#93c5fd"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🖼️ Logo Requirements
              </h4>
              <p style={{ color: darkMode ? "#bfdbfe" : "#1d4ed8", margin: 0 }}>
                Keep logos under <strong>1 MB</strong> for best performance.
              </p>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              💳 PayFast Integration
            </h3>
            <p style={{ marginBottom: "20px" }}>
              FilingStack Accounting software also offers a Pay Now button on
              invoices sent to clients. This allows your clients to pay you via{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://payfast.io/"
                style={{ color: "#0891b2", textDecoration: "underline" }}
              >
                Payfast
              </a>
              .
            </p>

            <p style={{ marginBottom: "20px" }}>
              This can be enabled on the Invoices Added page and requires your
              Payfast merchant ID to be entered. Visit the{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://payfast.io/"
                style={{ color: "#0891b2", textDecoration: "underline" }}
              >
                Payfast
              </a>{" "}
              website to create a Payfast account.
            </p>

            <div
              style={{
                backgroundColor: "#fff7ed",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #fed7aa",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#9a3412",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                💰 Payment Processing Fees
              </h4>
              <p style={{ color: "#ea580c", marginBottom: "12px" }}>
                Please ensure that the split payments option is enabled on the
                Payment methods page under the Settings link on the Payfast
                Dashboard.
              </p>
              <p style={{ color: "#ea580c", margin: 0 }}>
                Commission of 3.6% + R2 + VAT is deducted to cater for Payfast
                payment processing fees. For example: if you send an invoice
                with an amount of R100 and the Pay Now button enabled, after
                your client pays you via Payfast, the amount you'll receive will
                be R93.56. We recommend adding this additional amount onto your
                invoice before you send it to a client.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Invoices Visual"
                  src={DisplayImage("invoices.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>
          </DocSection>

          {/* Section 10: Inventory Management */}
          <DocSection
            id="inventory"
            title="📦 Inventory Management"
            emoji="📦"
            darkMode={darkMode}
            isCollapsed={collapsedSections.inventory}
            onToggle={() => toggleSection("inventory")}
          >
            <p style={{ fontSize: "1.05rem", lineHeight: "1.7" }}>
              The <strong>Inventory Management</strong> feature provides
              comprehensive tools to track stock levels, manage product
              movements, and monitor inventory value in real-time.
            </p>

            <div
              style={{
                backgroundColor: darkMode ? "#134e4a" : "#f0fdfa",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#14b8a6" : "#99f6e4"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#5eead4" : "#0f766e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🎯 Key Features
              </h4>

              <div style={{ color: darkMode ? "#99f6e4" : "#115e59" }}>
                <p>
                  <strong>📊 Dashboard & Analytics:</strong>
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>Real-time inventory value tracking</li>
                  <li>Total products count and stock movements</li>
                  <li>Category-wise breakdown and analysis</li>
                  <li>Valuation reports (cost vs retail)</li>
                </ul>

                <p>
                  <strong>⚠️ Low Stock Alerts:</strong>
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>
                    Automatic detection of products below minimum threshold
                  </li>
                  <li>Visual warning indicators and badges</li>
                  <li>Configurable alert levels per product</li>
                  <li>Prevent stockouts before they happen</li>
                </ul>

                <p>
                  <strong>🔍 Search & Organization:</strong>
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>Search by product name, SKU, or barcode</li>
                  <li>Filter by category</li>
                  <li>Quick product lookup</li>
                  <li>Organized product categories</li>
                </ul>

                <p>
                  <strong>📝 Stock Movement Tracking:</strong>
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>Complete audit trail of all inventory changes</li>
                  <li>Track who made changes and when</li>
                  <li>Record reasons for adjustments</li>
                  <li>View previous and new quantities</li>
                  <li>Export movement history to Excel</li>
                </ul>

                <p>
                  <strong>🏷️ Product Information:</strong>
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>SKU (Stock Keeping Unit) codes</li>
                  <li>Barcode support for scanning</li>
                  <li>Product categories and grouping</li>
                  <li>Minimum stock level settings</li>
                  <li>Last purchase price for valuation</li>
                  <li>Current quantity and selling price</li>
                </ul>
              </div>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#eff6ff",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#3b82f6" : "#bfdbfe"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🚀 How to Use
              </h4>

              <div style={{ color: darkMode ? "#bfdbfe" : "#1e3a8a" }}>
                <p>
                  <strong>Setting Up Products:</strong>
                </p>
                <ol style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>
                    Navigate to <strong>Products Added</strong> page
                  </li>
                  <li>
                    Add or edit products with new inventory fields:
                    <ul style={{ marginLeft: "20px", marginTop: "8px" }}>
                      <li>SKU code for internal tracking</li>
                      <li>Barcode for scanning</li>
                      <li>Category for organization</li>
                      <li>Current quantity in stock</li>
                      <li>Minimum stock level (for alerts)</li>
                      <li>Last purchase price (for cost tracking)</li>
                    </ul>
                  </li>
                  <li>Save product details</li>
                </ol>

                <p>
                  <strong>Viewing Inventory Dashboard:</strong>
                </p>
                <ol style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>
                    Click the <strong>"View Inventory Management"</strong> link
                    on Products Added page
                  </li>
                  <li>
                    Or navigate directly to{" "}
                    <code>filingstack.com/inventory-management</code>
                  </li>
                  <li>
                    View summary cards showing:
                    <ul style={{ marginLeft: "20px", marginTop: "8px" }}>
                      <li>Total products in system</li>
                      <li>Low stock alerts (red if issues exist)</li>
                      <li>Total inventory value</li>
                      <li>Number of stock movements</li>
                    </ul>
                  </li>
                </ol>

                <p>
                  <strong>Adjusting Stock Levels:</strong>
                </p>
                <ol style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>
                    Go to <strong>Products</strong> tab in Inventory Management
                  </li>
                  <li>
                    Click <strong>"Adjust"</strong> button on any product
                  </li>
                  <li>Select adjustment type (Add or Remove stock)</li>
                  <li>Enter quantity to adjust</li>
                  <li>
                    Provide reason (e.g., "New stock received", "Damaged goods")
                  </li>
                  <li>Confirm adjustment - movement is automatically logged</li>
                </ol>

                <p>
                  <strong>Viewing Movement History:</strong>
                </p>
                <ol style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>
                    Click <strong>"Movements"</strong> tab
                  </li>
                  <li>View chronological history of all stock changes</li>
                  <li>See who made each change and when</li>
                  <li>Export to Excel for external reporting</li>
                </ol>

                <p>
                  <strong>Generating Reports:</strong>
                </p>
                <ol style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>
                    Click <strong>"Reports"</strong> tab
                  </li>
                  <li>View inventory by category</li>
                  <li>See valuation methods (cost vs retail)</li>
                  <li>Export full product list to Excel from Products tab</li>
                </ol>
              </div>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#7c2d12" : "#fef7f0",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#ea580c" : "#fed7aa"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fed7aa" : "#9a3412",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                💡 Best Practices
              </h4>
              <ul
                style={{
                  color: darkMode ? "#fdba74" : "#7c2d12",
                  marginLeft: "20px",
                }}
              >
                <li>
                  <strong>Set Realistic Minimum Levels:</strong> Configure
                  minimum stock levels based on your typical sales velocity and
                  supplier lead times
                </li>
                <li>
                  <strong>Regular Stock Takes:</strong> Periodically verify
                  physical stock matches system records and adjust as needed
                </li>
                <li>
                  <strong>Document Adjustments:</strong> Always provide clear
                  reasons when adjusting stock to maintain audit trail
                </li>
                <li>
                  <strong>Use SKU Codes:</strong> Implement a consistent SKU
                  naming convention for easy product identification
                </li>
                <li>
                  <strong>Track Purchase Prices:</strong> Update last purchase
                  price when receiving new stock for accurate valuation
                </li>
                <li>
                  <strong>Monitor Low Stock:</strong> Check the dashboard
                  regularly for low stock alerts to prevent stockouts
                </li>
                <li>
                  <strong>Export Reports:</strong> Generate Excel reports
                  monthly for inventory reconciliation
                </li>
              </ul>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#312e81" : "#eef2ff",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#818cf8" : "#c7d2fe"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#c7d2fe" : "#3730a3",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🔍 Barcode Scanning
              </h4>

              <p
                style={{
                  color: darkMode ? "#e0e7ff" : "#4338ca",
                  marginBottom: "16px",
                }}
              >
                Speed up product lookups and stock adjustments with integrated
                barcode scanning support.
              </p>

              <div style={{ color: darkMode ? "#e0e7ff" : "#312e81" }}>
                <p>
                  <strong>📱 Two Ways to Scan:</strong>
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>
                    <strong>USB Barcode Scanner (Recommended):</strong>
                    <ul style={{ marginTop: "8px", marginLeft: "20px" }}>
                      <li>
                        Focus the barcode input field on inventory or product
                        pages
                      </li>
                      <li>Scan any product barcode with your USB scanner</li>
                      <li>
                        Product loads automatically - works like keyboard input
                      </li>
                      <li>No setup required - plug and play</li>
                      <li>
                        Most reliable option for warehouse/retail environments
                      </li>
                    </ul>
                  </li>
                  <li style={{ marginTop: "12px" }}>
                    <strong>Camera Scanning (Mobile-Friendly):</strong>
                    <ul style={{ marginTop: "8px", marginLeft: "20px" }}>
                      <li>Click "📷 Scan with Camera" button</li>
                      <li>Allow camera access when prompted by browser</li>
                      <li>Point camera at barcode in good lighting</li>
                      <li>Product loads automatically when detected</li>
                      <li>Perfect for mobile devices and tablets</li>
                    </ul>
                  </li>
                </ul>

                <p>
                  <strong>✅ Supported Barcode Formats:</strong>
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>UPC-A, UPC-E (retail products in North America)</li>
                  <li>EAN-8, EAN-13 (international retail products)</li>
                  <li>Code 128, Code 39, Code 93 (custom inventory codes)</li>
                  <li>ITF, Codabar (warehouse and logistics)</li>
                  <li>QR codes (for product information)</li>
                  <li>And many more industry-standard formats</li>
                </ul>

                <p>
                  <strong>🎯 Where to Use Barcode Scanning:</strong>
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>
                    <strong>Inventory Management Page:</strong> Quick product
                    lookup and stock adjustments
                  </li>
                  <li>
                    <strong>Product Details Page:</strong> Fast product
                    selection for editing
                  </li>
                  <li>
                    <strong>Stock Takes:</strong> Rapid product verification
                    during inventory counts
                  </li>
                  <li>
                    <strong>Receiving Stock:</strong> Quick data entry when
                    receiving deliveries
                  </li>
                </ul>

                <p>
                  <strong>💡 Pro Tips:</strong>
                </p>
                <ul style={{ marginLeft: "20px" }}>
                  <li>
                    <strong>USB Scanners:</strong> Most affordable option, works
                    instantly without setup, no camera permissions needed.
                    Perfect for fixed locations.
                  </li>
                  <li>
                    <strong>Mobile Devices:</strong> Use camera scanning for
                    on-the-go inventory checks and stocktakes without additional
                    hardware.
                  </li>
                  <li>
                    <strong>Good Lighting:</strong> Ensure adequate lighting
                    when using camera scanning. USB scanners work in any
                    lighting condition.
                  </li>
                  <li>
                    <strong>Manual Fallback:</strong> Can always type SKU or
                    barcode manually if scanning isn't working.
                  </li>
                  <li>
                    <strong>Unique Codes:</strong> Ensure each product has a
                    unique barcode or SKU to avoid confusion.
                  </li>
                  <li>
                    <strong>Print Labels:</strong> Use barcode label printers to
                    create professional labels for custom products without
                    manufacturer barcodes.
                  </li>
                </ul>
              </div>
            </div>
          </DocSection>

          {/* Section 11: Edit account names */}
          <DocSection
            id="10"
            title="Edit Account Names"
            emoji="✏️"
            darkMode={darkMode}
            isCollapsed={collapsedSections.openingBalances}
            onToggle={() => toggleSection("openingBalances")}
          >
            <div
              style={{
                backgroundColor: darkMode ? "#7c2d12" : "#fef7f0",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#9a3412" : "#fed7d7"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fed7aa" : "#92400e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📝 Financial Statement Accounts
              </h4>
              <p style={{ color: darkMode ? "#fdba74" : "#7c2d12", margin: 0 }}>
                Use the <strong>soCI</strong> and <strong>soFP</strong> pages to
                customize account names for your financial statements.
              </p>
            </div>
          </DocSection>

          {/* Section 11: SOCE */}
          <DocSection
            id="11"
            title="SOCE (Statement of Changes in Equity)"
            emoji="⚖️"
            darkMode={darkMode}
            isCollapsed={collapsedSections.financialStatements}
            onToggle={() => toggleSection("financialStatements")}
          >
            <div
              style={{
                backgroundColor: darkMode ? "#581c87" : "#faf5ff",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#6b21a8" : "#d8b4fe"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#e9d5ff" : "#6b21a8",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ✅ Equity Column Management
              </h4>
              <p style={{ color: darkMode ? "#d8b4fe" : "#9333ea", margin: 0 }}>
                Use checkboxes to enable each equity column. Only enable columns
                that contain data for your entity.
              </p>
            </div>
          </DocSection>

          {/* Section 12: Journals */}
          <DocSection
            id="12"
            title="Journal Entries"
            emoji="📓"
            darkMode={darkMode}
            isCollapsed={collapsedSections.journalsPage}
            onToggle={() => toggleSection("journalsPage")}
          >
            <RecentWorkflowGuide guideKey="depreciation" darkMode={darkMode} />
            <div
              style={{
                backgroundColor: darkMode ? "#7f1d1d" : "#fef2f2",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#991b1b" : "#fecaca"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fca5a5" : "#991b1b",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📝 Add & Edit Journals
              </h4>
              <p style={{ color: darkMode ? "#fca5a5" : "#dc2626", margin: 0 }}>
                Use the Journals page to add journal entries. All edits save
                automatically. You can also upload journals via CSV file.
              </p>
            </div>

            <h3
              style={{
                color: darkMode ? "#e2e8f0" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📊 CSV Upload Format
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Your CSV file needs <strong>five columns</strong>: Date, Journal
              Name, Journal Amount, Debit Account, and Credit Account. The debit
              and credit accounts must match existing accounts in FilingStack.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Journals Visual"
                  src={DisplayImage("journals.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              💰 Opening Balances Guide
            </h3>

            <div
              style={{
                backgroundColor: "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #93c5fd",
                marginBottom: "20px",
              }}
            >
              <h4
                style={{
                  color: "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🏦 Retained Income Setup
              </h4>
              <p style={{ color: "#1d4ed8", margin: 0 }}>
                Opening balances can be posted on the Journals page. Use the
                Retained income account or a similar account (Opening balances -
                Equity, if the trial balance doesn't have retained income) as
                the contra account for ALL opening balance entries. Don't enter
                the Retained Income opening balance amount from your trial
                balance, as the software will automatically calculate the
                Retained Income amount.
              </p>
            </div>

            <h4
              style={{
                color: "#1e293b",
                fontSize: "1.2rem",
                marginBottom: "16px",
              }}
            >
              🏛️ Bank Account Opening Balances
            </h4>
            <p style={{ marginBottom: "20px" }}>
              To add a bank account opening balance there are two options
              available:
            </p>
            <ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
              <li style={{ marginBottom: "8px" }}>
                Add a current asset Account with the bank account name (then
                post journal entry), using the Add button on the Accounts page
                (on the Account group column)
              </li>
              <li>
                Use the Add Bank Account option on the Accounts page to add the
                bank account and opening balance (no journal entry required)
              </li>
            </ul>

            <div
              style={{
                backgroundColor: "#fff7ed",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #fed7aa",
                marginBottom: "20px",
              }}
            >
              <h4
                style={{
                  color: "#9a3412",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ⚠️ Important Timing Note
              </h4>
              <p style={{ color: "#ea580c", margin: 0 }}>
                To ensure that the current year's income statement doesn't
                include prior year opening balances, enter all opening balances
                in the same year that the opening balance transactions occurred.
              </p>
            </div>

            <p>The Accounts page can also be used to enter opening balances.</p>
          </DocSection>

          {/* Section 13: VAT and Provisional Tax calculations */}
          <DocSection
            id="13"
            title="VAT & Provisional Tax"
            emoji="🧾"
            darkMode={darkMode}
            isCollapsed={collapsedSections.provisionalTax}
            onToggle={() => toggleSection("provisionalTax")}
          >
            <div
              style={{
                backgroundColor: "#f3e8ff",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #c4b5fd",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#7c2d12",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🧾 VAT Page Access
              </h4>
              <p style={{ color: "#7c3aed", margin: 0 }}>
                The Tax page has a link to the VAT page. VAT period dates must
                be selected to show VAT transactions for the period.
              </p>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📅 Multi-Year VAT Periods
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Transactions for VAT periods that involve multiple financial years
              must be added per year. The VAT page is enabled through options on
              the Tax page.
            </p>

            <div
              style={{
                backgroundColor: "#fef2f2",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #fecaca",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#991b1b",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🔒 Date Lockdown Feature
              </h4>
              <p style={{ color: "#dc2626", margin: 0 }}>
                The VAT page also has options to lockdown dates to prevent
                editing to those transactions and entries on the Accounts and
                journals pages.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="VAT Page Visual"
                  src={DisplayImage("vat.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <h3
              style={{
                color: darkMode ? "#e2e8f0" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              🇿🇦 Provisional Tax Calculation
            </h3>
            <p style={{ marginBottom: "20px" }}>
              The Provisional Tax page generates automated calculations for your
              selected entity, based on{" "}
              <strong>2025 South African tax rates</strong>.
            </p>
          </DocSection>

          {/* Section 14: Payslips & Payroll */}
          <DocSection
            id="14"
            title="Payslips & Payroll"
            emoji="💰"
            darkMode={darkMode}
            isCollapsed={collapsedSections.payslips}
            onToggle={() => toggleSection("payslips")}
          >
            <RecentWorkflowGuide guideKey="payroll" darkMode={darkMode} />
            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              🧾 Payroll Setup Process
            </h3>
            <p style={{ marginBottom: "20px" }}>
              The Tax page has options for payslip generation. The Payroll pages
              are enabled through options available on the 'Tax' page. The
              salary Tax page works after at least 1 employee has been added,
              using the Add Employee page.
            </p>

            <div
              style={{
                backgroundColor: "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #a7f3d0",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📋 Prerequisites
              </h4>
              <p style={{ color: "#059669", marginBottom: "12px" }}>
                The salary Tax page should be accessed after at least 1 employee
                has been added. Currently tax rates are applicable for South
                Africa.
              </p>
              <p style={{ color: "#059669", margin: 0 }}>
                If users are manually changing the PAYE or UIF values, the gross
                salary must be re-entered.
              </p>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              ⏰ Pay Period Configuration
            </h3>
            <p style={{ marginBottom: "20px" }}>
              The pay periods worked must be saved prior to entering payroll
              data to enable the salary calculation to work with the correct
              period.
            </p>

            <div
              style={{
                backgroundColor: "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #93c5fd",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🏥 Medical Aid & Net-to-Gross
              </h4>
              <p style={{ color: "#1d4ed8", marginBottom: "12px" }}>
                The medical Aid Tax credits must also be saved for the salary
                calculation to use its value.
              </p>
              <p style={{ color: "#1d4ed8", margin: 0 }}>
                The net to gross option calculates assuming a fixed 12 monthly
                salary.
              </p>
            </div>

            <h3
              style={{
                color: darkMode ? "#e2e8f0" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              💼 Employment Tax Incentive (ETI)
            </h3>
            <p style={{ marginBottom: "20px" }}>
              FilingStack automatically calculates the Employment Tax Incentive
              (ETI) as per Section 7 of the Employment Tax Incentive Act. This
              incentive helps employers reduce their PAYE liability when hiring
              eligible employees.
            </p>

            <div
              style={{
                backgroundColor: darkMode ? "#14532d" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#166534" : "#a7f3d0"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#86efac" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ✨ Automatic ETI Calculation
              </h4>
              <p
                style={{
                  color: darkMode ? "#a7f3d0" : "#059669",
                  marginBottom: "12px",
                }}
              >
                ETI is calculated automatically based on:
              </p>
              <ul
                style={{
                  color: darkMode ? "#a7f3d0" : "#059669",
                  margin: 0,
                  paddingLeft: "20px",
                  lineHeight: "1.8",
                }}
              >
                <li>Employee's monthly wage/salary</li>
                <li>Employment start date (to determine qualifying cycle)</li>
                <li>Number of months employed in current tax year</li>
                <li>Applicable SARS rate schedule based on calculation date</li>
              </ul>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#7f1d1d" : "#fef2f2",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#991b1b" : "#fecaca"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fca5a5" : "#991b1b",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📅 2025 SARS Rate Updates
              </h4>
              <p
                style={{
                  color: darkMode ? "#fecaca" : "#dc2626",
                  marginBottom: "12px",
                }}
              >
                Effective <strong>1 April 2025</strong>, SARS updated the ETI
                thresholds and percentages. FilingStack automatically applies
                the correct rates based on your payroll date:
              </p>
              <div style={{ display: "grid", gap: "16px" }}>
                <div>
                  <strong style={{ color: darkMode ? "#fca5a5" : "#991b1b" }}>
                    Before 1 April 2025:
                  </strong>
                  <ul
                    style={{
                      color: darkMode ? "#fecaca" : "#dc2626",
                      marginLeft: "20px",
                      marginTop: "8px",
                    }}
                  >
                    <li>Threshold: R2,000/month</li>
                    <li>Maximum wage: R6,500/month</li>
                    <li>Percentages: 75% / 37.5% (first/second year)</li>
                  </ul>
                </div>
                <div>
                  <strong style={{ color: darkMode ? "#fca5a5" : "#991b1b" }}>
                    From 1 April 2025:
                  </strong>
                  <ul
                    style={{
                      color: darkMode ? "#fecaca" : "#dc2626",
                      marginLeft: "20px",
                      marginTop: "8px",
                    }}
                  >
                    <li>Threshold: R2,500/month (increased)</li>
                    <li>Maximum wage: R7,500/month (increased)</li>
                    <li>Percentages: 60% / 30% and 75% / 37.5% (tiered)</li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1e40af" : "#93c5fd"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📊 How ETI is Calculated
              </h4>
              <div style={{ color: darkMode ? "#bfdbfe" : "#1d4ed8" }}>
                <p style={{ marginBottom: "12px" }}>
                  <strong>Step 1:</strong> System determines which "cycle" the
                  employee is in:
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>First 12 months of employment = Cycle 1 (higher rate)</li>
                  <li>Months 13-24 = Cycle 2 (lower rate)</li>
                  <li>After 24 months = No ETI</li>
                </ul>

                <p style={{ marginBottom: "12px" }}>
                  <strong>Step 2:</strong> Applies wage-based formula:
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                  <li>Below threshold: Fixed amount (R1,500)</li>
                  <li>
                    Between threshold and upper limit: Sliding scale reduction
                  </li>
                  <li>Above upper limit: R0 ETI</li>
                </ul>

                <p style={{ marginBottom: "0" }}>
                  <strong>Step 3:</strong> Reduces your monthly PAYE liability
                  by the calculated ETI amount
                </p>
              </div>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#78350f" : "#fef3c7",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#92400e" : "#fcd34d"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fcd34d" : "#92400e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ⚠️ Important Notes
              </h4>
              <ul
                style={{
                  color: darkMode ? "#fde68a" : "#a16207",
                  margin: 0,
                  paddingLeft: "20px",
                  lineHeight: "1.8",
                }}
              >
                <li>
                  ETI is automatically recalculated whenever you change employee
                  wage or employment date
                </li>
                <li>
                  The system tracks months employed within the current tax year
                </li>
                <li>
                  ETI fields will show R0 if employee doesn't qualify (wage too
                  high or employed too long)
                </li>
                <li>
                  Changes to tax year selection will trigger ETI recalculation
                  for the selected period
                </li>
                <li>
                  Ensure employment start dates are accurate for correct cycle
                  determination
                </li>
              </ul>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📒 Payroll Journal Entries
            </h3>
            <p style={{ marginBottom: "20px" }}>
              After calculating payroll, you can post journal entries directly
              from the Tax Calculation page to record payroll expenses in your
              accounting system.
            </p>

            <div
              style={{
                backgroundColor: "#f0fdf4",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #86efac",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#14532d",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📝 Journal Entry Features
              </h4>
              <ul
                style={{
                  color: "#166534",
                  margin: 0,
                  paddingLeft: "20px",
                  lineHeight: "1.8",
                }}
              >
                <li>
                  Click "Create Journal Entry" button after completing payroll
                  calculations
                </li>
                <li>
                  Pre-populated with employee name and gross salary amount
                </li>
                <li>
                  Default accounts: Debit "Salaries & Wages", Credit "Accrued
                  expenses"
                </li>
                <li>
                  Select custom accounts from dropdown (includes Chart of
                  Accounts + custom accounts)
                </li>
                <li>Preview paired journal entries before posting</li>
                <li>Posts to Unified Transactions with source: "payroll"</li>
              </ul>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              🎯 Payroll Navigation Structure
            </h3>
            <p style={{ marginBottom: "20px" }}>
              The payroll system has been organized into three separate dropdown
              menus for better navigation:
            </p>

            <div style={{ display: "grid", gap: "16px", marginBottom: "24px" }}>
              <div
                style={{
                  backgroundColor: "#fef2f2",
                  padding: "16px",
                  borderRadius: "12px",
                  border: "2px solid #ef4444",
                }}
              >
                <h4
                  style={{
                    color: "#991b1b",
                    marginBottom: "8px",
                    fontSize: "1.05rem",
                  }}
                >
                  👥 Payroll Actions (Red)
                </h4>
                <ul
                  style={{ color: "#dc2626", margin: 0, paddingLeft: "20px" }}
                >
                  <li>💰 Salary Tax - Calculate employee tax and payroll</li>
                  <li>➕ Add Employee - Add new employees to the system</li>
                  <li>🏢 Employer Details - Configure employer settings</li>
                </ul>
              </div>

              <div
                style={{
                  backgroundColor: "#f0fdf4",
                  padding: "16px",
                  borderRadius: "12px",
                  border: "2px solid #10b981",
                }}
              >
                <h4
                  style={{
                    color: "#065f46",
                    marginBottom: "8px",
                    fontSize: "1.05rem",
                  }}
                >
                  🏖️ Leave Management (Green)
                </h4>
                <ul
                  style={{ color: "#059669", margin: 0, paddingLeft: "20px" }}
                >
                  <li>
                    📅 Leave Management - Track employee leave requests and
                    balances
                  </li>
                </ul>
              </div>

              <div
                style={{
                  backgroundColor: "#eff6ff",
                  padding: "16px",
                  borderRadius: "12px",
                  border: "2px solid #3b82f6",
                }}
              >
                <h4
                  style={{
                    color: "#1e40af",
                    marginBottom: "8px",
                    fontSize: "1.05rem",
                  }}
                >
                  📊 Payroll Reports & Exports (Blue)
                </h4>
                <ul
                  style={{ color: "#1d4ed8", margin: 0, paddingLeft: "20px" }}
                >
                  <li>
                    📊 Payroll Reports - View payroll summaries and reports
                  </li>
                  <li>📤 Export - Export payroll data to various formats</li>
                  <li>📋 EMP201 Report - Generate SARS monthly declaration</li>
                </ul>
              </div>
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📅 Payroll Frequency Configuration
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Configure how often payroll is run for your business in the
              Employer Details page.
            </p>

            <div
              style={{
                backgroundColor: "#fef9e6",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #fbbf24",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#78350f",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ⚙️ Available Frequency Options
              </h4>
              <ul
                style={{
                  color: "#92400e",
                  margin: 0,
                  paddingLeft: "20px",
                  lineHeight: "1.8",
                }}
              >
                <li>
                  <strong>Weekly</strong> - For businesses that pay employees
                  every week
                </li>
                <li>
                  <strong>Bi-weekly (Fortnightly)</strong> - Pay every two weeks
                </li>
                <li>
                  <strong>Monthly</strong> - Default option, most common in
                  South Africa
                </li>
                <li>
                  <strong>Quarterly</strong> - For seasonal or contract-based
                  payroll
                </li>
              </ul>
              <p
                style={{ color: "#92400e", marginTop: "12px", marginBottom: 0 }}
              >
                This setting is saved to the employer's payroll configuration
                and helps ensure accurate payroll calculations based on your
                payment schedule.
              </p>
            </div>

            <h3
              style={{
                color: darkMode ? "#e2e8f0" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
                marginTop: "32px",
              }}
            >
              📋 IRP5 Tax Certificates & SARS Exports
            </h3>
            <p style={{ marginBottom: "20px" }}>
              FilingStack generates SARS-compliant IRP5/IT3(a) tax certificates
              for all employees. These certificates are essential for annual tax
              submissions and employee tax returns.
            </p>

            <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1e40af" : "#93c5fd"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📤 e@syFile Export
              </h4>
              <p
                style={{
                  color: darkMode ? "#bfdbfe" : "#1d4ed8",
                  marginBottom: "12px",
                }}
              >
                Export your payroll data directly to SARS e@syFile format for
                seamless submission. The export includes:
              </p>
              <ul
                style={{
                  color: darkMode ? "#bfdbfe" : "#1d4ed8",
                  margin: 0,
                  paddingLeft: "20px",
                  lineHeight: "1.8",
                }}
              >
                <li>IRP5 data for each employee</li>
                <li>EMP501 reconciliation totals</li>
                <li>Employer contribution summaries</li>
                <li>Tax certificate reference numbers</li>
              </ul>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#14532d" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#166534" : "#a7f3d0"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#86efac" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ✅ What's Included in Each Plan
              </h4>
              <p
                style={{
                  color: darkMode ? "#a7f3d0" : "#059669",
                  marginBottom: "12px",
                }}
              >
                Payroll is included with all FilingStack subscription plans:
              </p>
              <ul
                style={{
                  color: darkMode ? "#a7f3d0" : "#059669",
                  margin: 0,
                  paddingLeft: "20px",
                  lineHeight: "1.8",
                }}
              >
                <li>
                  <strong>Starter Plan (R70/month):</strong> 2 employees
                  included
                </li>
                <li>
                  <strong>Pro Plan (R180/month):</strong> 5 employees included
                </li>
                <li>
                  <strong>Additional employees:</strong> R18 per employee per
                  month
                </li>
              </ul>
            </div>

            <h3
              style={{
                color: darkMode ? "#e2e8f0" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📊 Payroll Reports Available
            </h3>
            <div style={{ display: "grid", gap: "12px", marginBottom: "24px" }}>
              <div
                style={{
                  backgroundColor: darkMode ? "#374151" : "#f8fafc",
                  padding: "16px",
                  borderRadius: "8px",
                  border: `1px solid ${darkMode ? "#4b5563" : "#e2e8f0"}`,
                }}
              >
                <strong style={{ color: darkMode ? "#f3f4f6" : "#1e293b" }}>
                  IRP5 Certificates
                </strong>
                <p
                  style={{
                    margin: "8px 0 0 0",
                    fontSize: "0.9rem",
                    color: darkMode ? "#9ca3af" : "#64748b",
                  }}
                >
                  Individual tax certificates for each employee showing
                  earnings, deductions, and tax paid
                </p>
              </div>
              <div
                style={{
                  backgroundColor: darkMode ? "#374151" : "#f8fafc",
                  padding: "16px",
                  borderRadius: "8px",
                  border: `1px solid ${darkMode ? "#4b5563" : "#e2e8f0"}`,
                }}
              >
                <strong style={{ color: darkMode ? "#f3f4f6" : "#1e293b" }}>
                  EMP201 Monthly Declaration
                </strong>
                <p
                  style={{
                    margin: "8px 0 0 0",
                    fontSize: "0.9rem",
                    color: darkMode ? "#9ca3af" : "#64748b",
                  }}
                >
                  Monthly PAYE, UIF, and SDL totals for SARS submission (due by
                  7th of following month)
                </p>
              </div>
              <div
                style={{
                  backgroundColor: darkMode ? "#374151" : "#f8fafc",
                  padding: "16px",
                  borderRadius: "8px",
                  border: `1px solid ${darkMode ? "#4b5563" : "#e2e8f0"}`,
                }}
              >
                <strong style={{ color: darkMode ? "#f3f4f6" : "#1e293b" }}>
                  EMP501 Reconciliation
                </strong>
                <p
                  style={{
                    margin: "8px 0 0 0",
                    fontSize: "0.9rem",
                    color: darkMode ? "#9ca3af" : "#64748b",
                  }}
                >
                  Annual employer reconciliation showing all employees and tax
                  certificates issued
                </p>
              </div>
              <div
                style={{
                  backgroundColor: darkMode ? "#374151" : "#f8fafc",
                  padding: "16px",
                  borderRadius: "8px",
                  border: `1px solid ${darkMode ? "#4b5563" : "#e2e8f0"}`,
                }}
              >
                <strong style={{ color: darkMode ? "#f3f4f6" : "#1e293b" }}>
                  Payslips
                </strong>
                <p
                  style={{
                    margin: "8px 0 0 0",
                    fontSize: "0.9rem",
                    color: darkMode ? "#9ca3af" : "#64748b",
                  }}
                >
                  Individual payslips for each pay period showing gross pay,
                  deductions, and net pay
                </p>
              </div>
            </div>
          </DocSection>

          {/* Section 15: Financial statement generation */}
          <DocSection
            id="15"
            title="Financial statement generation"
            emoji="📈"
            darkMode={darkMode}
            isCollapsed={collapsedSections.financialStatements}
            onToggle={() => toggleSection("financialStatements")}
          >
            {/* New Date Filter Feature for Financial Statements */}
            <RecentWorkflowGuide guideKey="reporting" darkMode={darkMode} />
            <FeatureHighlight
              title="📅 Date Range Filtering for Financial Statements"
              badge="ENHANCED"
              darkMode={darkMode}
              features={[
                "SOFP (Statement of Financial Position): Filter by end date to view balance sheet at specific points in time",
                "SOCI (Statement of Comprehensive Income): Select start and end dates for the reporting period",
                "Cash Flow Statement: Full date range filtering with start and end dates",
                "Quick presets: This Month, Last Month, This Quarter, This Year",
                "Year dropdown for historical comparisons",
                "Real-time statement updates when date filters change",
              ]}
            />

            {/* Step-by-step Guide for Financial Statement Date Filtering */}
            <div style={{ marginTop: "32px" }}>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  marginBottom: "24px",
                  color: darkMode ? "#e2e8f0" : "#1e293b",
                }}
              >
                Using Date Filters on Financial Statements
              </h3>

              <StepCard
                number={1}
                title="SOFP - End Date Filtering"
                darkMode={darkMode}
              >
                <p style={{ marginBottom: "12px" }}>
                  Navigate to SOFP (Statement of Financial Position). Use the
                  DateRangePicker to select an <strong>end date</strong> - this
                  shows your financial position at that specific point in time.
                </p>
                <div
                  style={{
                    padding: "12px",
                    backgroundColor: darkMode
                      ? "rgba(234, 179, 8, 0.1)"
                      : "#fef3c7",
                    borderRadius: "8px",
                    marginTop: "12px",
                  }}
                >
                  <p style={{ margin: 0, fontSize: "0.95rem" }}>
                    ⚠️ <strong>Why end date only?</strong> Balance sheets show
                    what you own and owe AT a specific point, not during a
                    period. SOFP includes ALL transactions from inception up to
                    your selected date.
                  </p>
                </div>
              </StepCard>

              <StepCard
                number={2}
                title="Cash Flow - Full Date Range"
                darkMode={darkMode}
              >
                On the Cash Flow Statement, select both start and end dates to
                analyze cash movements DURING a specific period. This is perfect
                for quarterly or monthly cash flow analysis.
              </StepCard>

              <StepCard
                number={3}
                title="Use Preset Periods"
                darkMode={darkMode}
              >
                <p style={{ marginBottom: "12px" }}>
                  Quick presets make common reporting periods easy:
                </p>
                <ul style={{ marginLeft: "20px", lineHeight: "1.8" }}>
                  <li>
                    <strong>This Month</strong> - Current month's financial data
                  </li>
                  <li>
                    <strong>This Quarter</strong> - Current quarter (Q1, Q2, Q3,
                    or Q4)
                  </li>
                  <li>
                    <strong>This Year</strong> - Current fiscal year
                  </li>
                  <li>
                    <strong>Last Year</strong> - Previous fiscal year for
                    comparisons
                  </li>
                </ul>
              </StepCard>

              <StepCard
                number={4}
                title="Generate PDF Reports"
                darkMode={darkMode}
              >
                After setting your date filters, navigate to the AFS page to
                generate a complete PDF containing all financial statements for
                your selected period.
              </StepCard>
            </div>

            {/* Important Notes */}
            <div
              style={{
                marginTop: "32px",
                padding: "20px",
                backgroundColor: darkMode
                  ? "rgba(16, 185, 129, 0.1)"
                  : "rgba(16, 185, 129, 0.05)",
                borderLeft: "4px solid #10b981",
                borderRadius: "8px",
              }}
            >
              <h4
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  marginBottom: "12px",
                  color: darkMode ? "#6ee7b7" : "#059669",
                }}
              >
                📌 Key Differences Between Statements
              </h4>
              <ul style={{ marginLeft: "20px", lineHeight: "1.8", margin: 0 }}>
                <li>
                  <strong>SOFP (Balance Sheet):</strong> Shows position AT a
                  date → Uses end date only
                </li>
                <li>
                  <strong>SOCI (Income Statement):</strong> Shows activity
                  DURING a period → Coming soon
                </li>
                <li>
                  <strong>Cash Flow:</strong> Shows cash movements DURING a
                  period → Full date range
                </li>
              </ul>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#7c2d12" : "#fff7ed",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#9a3412" : "#fed7aa"}`,
                marginBottom: "24px",
                marginTop: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#fed7aa" : "#9a3412",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📄 AFS Page Overview
              </h4>
              <p style={{ color: darkMode ? "#fdba74" : "#ea580c", margin: 0 }}>
                The AFS page loads all of the financial statements together into
                a PDF.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="AFS Visual"
                  src={DisplayImage("afs.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <h3
              style={{
                color: darkMode ? "#e2e8f0" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              ✅ Page Selection Options
            </h3>
            <p style={{ marginBottom: "20px" }}>
              There are checkboxes to select which pages should be included in
              the financials generated.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Pages Selection Visual"
                  src={DisplayImage("pages.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <h3
              style={{
                color: darkMode ? "#e2e8f0" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              🛠️ PDF Customization
            </h3>
            <p style={{ marginBottom: "20px" }}>
              Below the PDF displayed, there are non-editable application pages
              used for the PDF display. However, there are options to change the
              names of the financial statements, as well as the currency symbols
              and the Notes heading.
            </p>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="AFS Heading Visual"
                  src={DisplayImage("afsHeading.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1e40af" : "#93c5fd"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🔄 Refresh Requirements
              </h4>
              <p style={{ color: darkMode ? "#bfdbfe" : "#1d4ed8", margin: 0 }}>
                While this page may load automatically, the "Refresh PDF" button
                must be used to reflect changes made through the PDF
                customization options or other changes on the AFS page.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Financials Visual"
                  src={DisplayImage("financials.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#064e3b" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#065f46" : "#a7f3d0"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#6ee7b7" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                💡 Show/Hide Feature
              </h4>
              <p style={{ color: darkMode ? "#86efac" : "#059669", margin: 0 }}>
                Clicking on the title description (PDF customization options) on
                the AFS page will hide/unhide the PDF customization options
                table.
              </p>
            </div>
          </DocSection>

          {/* Section 16: Icons */}
          <DocSection
            id="16"
            title="User Icons & Settings"
            emoji="⚙️"
            darkMode={darkMode}
            isCollapsed={collapsedSections.icons}
            onToggle={() => toggleSection("icons")}
          >
            <div
              style={{
                backgroundColor: "#f0f9ff",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #7dd3fc",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#0c4a6e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                👤 User Profile Icon
              </h4>
              <p style={{ color: "#0891b2", margin: 0 }}>
                On the Navigation menu, there is a blue icon with the first
                letter of a user's email address. Clicking on it links to the
                Update profile page.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="User Icon Visual"
                  src={DisplayImage("icon.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <div
              style={{
                backgroundColor: "#fef2f2",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #fecaca",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#991b1b",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ⚠️ Company Name Updates
              </h4>
              <p style={{ color: "#dc2626", marginBottom: "12px" }}>
                On the Settings page, if the company/business name is updated,
                the company must be selected again from the company list on the
                My Entities page.
              </p>
              <p style={{ color: "#dc2626", margin: 0 }}>
                Otherwise certain pages may have incorrect values (e.g., the TB
                page).
              </p>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1e40af" : "#93c5fd"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🏢 Unique Company Names
              </h4>
              <p style={{ color: darkMode ? "#bfdbfe" : "#1d4ed8", margin: 0 }}>
                Each company must have a <strong>unique name</strong> when
                adding it to your profile.
              </p>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#052e16" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#14532d" : "#86efac"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#86efac" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🔐 Two-Factor Authentication (2FA)
              </h4>
              <p style={{ color: darkMode ? "#bbf7d0" : "#047857", marginBottom: "12px" }}>
                For stronger account security, open <strong>User Profile</strong>
                and enable <strong>Two-Factor Authentication</strong>. Once
                enabled, login requires your password plus either a 6-digit
                authenticator code or a backup code.
              </p>
              <ul style={{ color: darkMode ? "#bbf7d0" : "#047857", paddingLeft: "20px", margin: 0 }}>
                <li>Save your backup codes immediately after setup</li>
                <li>Regenerate backup codes from User Profile when needed</li>
                <li>
                  If you lose authenticator access and backup codes, contact
                  support with proof of identity
                </li>
              </ul>
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#172554" : "#eff6ff",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1d4ed8" : "#93c5fd"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🛡️ Security & Support Preferences
              </h4>
              <p style={{ color: darkMode ? "#bfdbfe" : "#1d4ed8", marginBottom: "12px" }}>
                User Profile also includes switches for <strong>Audit Logs</strong>
                and <strong>Live Chat</strong>. Keep Audit Logs enabled for
                stronger traceability, and keep Live Chat enabled if you want
                quick access to support in the app.
              </p>
              <p style={{ color: darkMode ? "#bfdbfe" : "#1d4ed8", margin: 0 }}>
                These settings affect how your team works and how quickly issues
                can be diagnosed.
              </p>
            </div>
          </DocSection>

          {/* Section 17: Payment information */}
          <DocSection
            id="17"
            title="Billing & Payments"
            emoji="💳"
            darkMode={darkMode}
            isCollapsed={collapsedSections.profilePage}
            onToggle={() => toggleSection("profilePage")}
          >
            <div
              style={{
                backgroundColor: darkMode ? "#064e3b" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#065f46" : "#a7f3d0"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#6ee7b7" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🎉 Free Trial
              </h4>
              <p style={{ color: darkMode ? "#86efac" : "#059669", margin: 0 }}>
                New users get <strong>at least 7 days free</strong>. Visit the
                Payments page to select a plan.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Payments Page Visual"
                  src={DisplayImage("payments1.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              💳 Billing Structure
            </h3>
            <p style={{ marginBottom: "20px" }}>
              The Payments page has options to select a plan for each entity
              added.
            </p>

            {/* <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Payment Plans Visual"
                  src={DisplayImage("payments2.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div> */}

            <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#dbeafe",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1e40af" : "#93c5fd"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🏦 Payment Method
              </h4>
              <p style={{ color: darkMode ? "#bfdbfe" : "#1d4ed8", margin: 0 }}>
                Pay via <strong>Payfast</strong>. You'll be redirected to their
                secure website to complete your payment.
              </p>
            </div>
          </DocSection>

          {/* Section 18: Bank feeds */}
          <DocSection
            id="18"
            title="Bank Feeds (Investec & FNB)"
            emoji="🏦"
            darkMode={darkMode}
            isCollapsed={collapsedSections.bankFeeds}
            onToggle={() => toggleSection("bankFeeds")}
          >
            <div
              style={{
                backgroundColor: darkMode ? "#581c87" : "#faf5ff",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#6b21a8" : "#d8b4fe"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#e9d5ff" : "#6b21a8",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🏦 Automated Bank Integrations
              </h4>
              <p style={{ color: darkMode ? "#d8b4fe" : "#9333ea", margin: 0 }}>
                Connect your <strong>Investec</strong> or <strong>FNB</strong>{" "}
                bank account to automatically sync transactions.
              </p>
            </div>

            {/* Investec Section */}
            <h3
              style={{
                color: darkMode ? "#e9d5ff" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
                marginTop: "32px",
              }}
            >
              🔷 Investec Bank Integration
            </h3>

            <h4
              style={{
                color: "#1e293b",
                fontSize: "1.1rem",
                marginBottom: "16px",
              }}
            >
              🔑 API Key Setup Process
            </h4>
            <p style={{ marginBottom: "20px" }}>
              You'll need to login to <strong>Investec online</strong> and
              navigate to the <strong>Tools</strong> page, select the{" "}
              <strong>Individual Connections</strong> tab and click the{" "}
              <strong>Create API key</strong> button.
            </p>

            <div
              style={{
                backgroundColor: "#fef2f2",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #fecaca",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#991b1b",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ⚠️ Prerequisites
              </h4>
              <p style={{ color: "#dc2626", margin: 0 }}>
                It's important that you have already added a company and bank
                account on FilingStack before connecting a bank feed, as
                transactions will be imported into the currently selected bank
                account.
              </p>
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Bank Feed Setup Visual"
                  src={DisplayImage("InfoNav.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <div style={{ textAlign: "left", margin: "24px 0" }}>
              {LoadingCheck(
                <img
                  alt="Connect Bank Visual"
                  src={DisplayImage("connectBank.png")}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                  }}
                />
              )}
            </div>

            <div
              style={{
                backgroundColor: darkMode ? "#064e3b" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#065f46" : "#a7f3d0"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#6ee7b7" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🔒 Security & Privacy
              </h4>
              <p style={{ color: darkMode ? "#86efac" : "#059669", margin: 0 }}>
                Your credentials are <strong>encrypted</strong> and never
                visible. FilingStack uses <strong>read-only API</strong>{" "}
                access—no payments can be made through the connection.
              </p>
            </div>

            {/* FNB Section */}
            <h3
              style={{
                color: darkMode ? "#e9d5ff" : "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
                marginTop: "48px",
                paddingTop: "24px",
                borderTop: `2px solid ${darkMode ? "#4b5563" : "#e5e7eb"}`,
              }}
            >
              🔶 FNB Bank Integration
            </h3>

            <div
              style={{
                backgroundColor: darkMode ? "#1e3a8a" : "#eff6ff",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#1e40af" : "#bfdbfe"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#93c5fd" : "#1e40af",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ℹ️ Requirements
              </h4>
              <p
                style={{
                  color: darkMode ? "#bfdbfe" : "#1e40af",
                  margin: "0 0 8px 0",
                }}
              >
                FNB bank feed integration requires an{" "}
                <strong>Enterprise Business Account</strong> with access to FNB
                Online Banking Enterprise (OBE). A Enterprise banking profile
                can be created for free. Contact FNB to register a Enterprise
                online banking profile.
              </p>
            </div>

            <h4
              style={{
                color: darkMode ? "#e9d5ff" : "#1e293b",
                fontSize: "1.1rem",
                marginBottom: "16px",
              }}
            >
              📋 Part 1: Adding a New User
            </h4>
            <p style={{ marginBottom: "16px" }}>
              The Administrator initiates the process, but the new user must
              complete their registration.
            </p>

            <StepCard
              number={1}
              title="Administrator Setup"
              darkMode={darkMode}
            >
              <ul style={{ marginLeft: "20px", lineHeight: "1.8" }}>
                <li>
                  Log in to <strong>FNB Online Banking Enterprise</strong>
                </li>
                <li>
                  Navigate to <strong>Profiles → User Dashboard</strong>
                </li>
                <li>
                  Select <strong>Add User</strong> and enter details (Full Name,
                  ID/Passport, mobile/email)
                </li>
                <li>
                  Assign Permissions: Copy from existing user or manually select
                  accounts and functions (e.g., "View Only" or "Capture")
                </li>
              </ul>
            </StepCard>

            <StepCard
              number={2}
              title="User Registration (Within 24 Hours)"
              darkMode={darkMode}
            >
              <ul style={{ marginLeft: "20px", lineHeight: "1.8" }}>
                <li>
                  User receives a unique <strong>Registration Code</strong> via
                  SMS or FNB App
                </li>
                <li>
                  Go to <strong>FNB Home Page</strong> and click{" "}
                  <strong>Register</strong>
                </li>
                <li>
                  Select{" "}
                  <strong>Register with an ID number and Security Code</strong>
                </li>
              </ul>
            </StepCard>

            <StepCard
              number={3}
              title="Authentication & App Linking"
              darkMode={darkMode}
            >
              <ul style={{ marginLeft: "20px", lineHeight: "1.8" }}>
                <li>
                  User creates their own <strong>Username and Password</strong>
                </li>
                <li>
                  Download the <strong>FNB Banking App</strong> on smartphone
                  and link it to the new profile
                </li>
                <li>
                  Create a <strong>4-digit PIN</strong> used for authorizing
                  logins and transactions
                </li>
              </ul>
            </StepCard>

            <h4
              style={{
                color: darkMode ? "#e9d5ff" : "#1e293b",
                fontSize: "1.1rem",
                marginBottom: "16px",
                marginTop: "32px",
              }}
            >
              🔌 Part 2: Enabling Transaction History API Syncing
            </h4>

            <StepCard
              number={1}
              title="Activate the Channel"
              darkMode={darkMode}
            >
              <ul style={{ marginLeft: "20px", lineHeight: "1.8" }}>
                <li>
                  Navigate to{" "}
                  <strong>Business Solutions → Integration Channel</strong>
                </li>
                <li>
                  Click <strong>Get Started</strong> and accept the Terms and
                  Conditions
                </li>
              </ul>
            </StepCard>

            <StepCard
              number={2}
              title="Configure API Settings"
              darkMode={darkMode}
            >
              <ul style={{ marginLeft: "20px", lineHeight: "1.8" }}>
                <li>
                  Go to <strong>View My Service Tasks</strong>
                </li>
                <li>
                  Change the <strong>Integration Type</strong> from Host-to-Host
                  to <strong>API</strong>
                </li>
                <li>
                  Locate and{" "}
                  <strong>Subscribe to the Transaction History API</strong>
                </li>
              </ul>
            </StepCard>

            <StepCard
              number={3}
              title="Generate Credentials"
              darkMode={darkMode}
            >
              <ul style={{ marginLeft: "20px", lineHeight: "1.8" }}>
                <li>
                  <strong>Consumption Method:</strong> Select "On my own behalf"
                </li>
                <li>
                  <strong>Connectivity Protocol:</strong> Click{" "}
                  <strong>Add Connectivity Protocol</strong> and select{" "}
                  <strong>REST API</strong>
                </li>
                <li>Assign a nickname to the connection</li>
                <li>
                  The system will generate a <strong>Client ID</strong> and{" "}
                  <strong>Client Secret</strong>
                </li>
              </ul>
              <div
                style={{
                  backgroundColor: "#fef2f2",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #fecaca",
                  marginTop: "16px",
                }}
              >
                <h5
                  style={{
                    color: "#991b1b",
                    marginBottom: "8px",
                    fontSize: "0.95rem",
                  }}
                >
                  ⚠️ Critical: Save Your Credentials
                </h5>
                <p style={{ color: "#dc2626", margin: 0, fontSize: "0.9rem" }}>
                  Copy the <strong>Client ID</strong> and{" "}
                  <strong>Client Secret</strong> immediately and store them
                  securely (e.g., in a password vault). They are{" "}
                  <strong>only shown once</strong> and cannot be recovered if
                  lost.
                </p>
              </div>
            </StepCard>

            <StepCard number={4} title="Link Accounts" darkMode={darkMode}>
              <p style={{ marginBottom: "12px" }}>
                Ensure you explicitly select which bank accounts are "mapped" or
                authorized for this API subscription.
              </p>
              <div
                style={{
                  backgroundColor: "#fef3c7",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #fcd34d",
                }}
              >
                <h5
                  style={{
                    color: "#92400e",
                    marginBottom: "8px",
                    fontSize: "0.95rem",
                  }}
                >
                  ⚡ Important
                </h5>
                <p style={{ color: "#b45309", margin: 0, fontSize: "0.9rem" }}>
                  Without this step, the API will return{" "}
                  <strong>empty data</strong> even with valid credentials.
                </p>
              </div>
            </StepCard>

            <div
              style={{
                backgroundColor: darkMode ? "#064e3b" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#065f46" : "#a7f3d0"}`,
                marginTop: "32px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#6ee7b7" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ✅ Next Steps
              </h4>
              <p
                style={{
                  color: darkMode ? "#86efac" : "#059669",
                  margin: "0 0 8px 0",
                }}
              >
                Once you have your FNB credentials:
              </p>
              <ol
                style={{
                  marginLeft: "20px",
                  color: darkMode ? "#86efac" : "#059669",
                  lineHeight: "1.8",
                }}
              >
                <li>
                  Navigate to the <strong>Bank Updates</strong> page in
                  FilingStack
                </li>
                <li>
                  Select <strong>FNB</strong> as your bank
                </li>
                <li>
                  Enter your <strong>Client ID</strong> and{" "}
                  <strong>Client Secret</strong>
                </li>
                <li>
                  Click <strong>Connect</strong> to start syncing transactions
                </li>
              </ol>
            </div>
          </DocSection>

          {/* Section 19: Quickstart Guide */}
          <DocSection
            id="19"
            title="Quickstart Guide"
            emoji="🚀"
            darkMode={darkMode}
            isCollapsed={collapsedSections.invoices}
            onToggle={() => toggleSection("invoices")}
          >
            <div
              style={{
                backgroundColor: darkMode ? "#064e3b" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#065f46" : "#a7f3d0"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#6ee7b7" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📋 Getting Started Overview
              </h4>
              <p style={{ color: darkMode ? "#86efac" : "#059669", margin: 0 }}>
                FilingStack lets you upload bank statements to automatically
                generate ledgers, trial balances, and financial statements. You
                can also export data for use in other accounting software.
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <h3
                style={{
                  color: darkMode ? "#e2e8f0" : "#1e293b",
                  fontSize: "1.3rem",
                  marginBottom: "16px",
                }}
              >
                Step-by-Step Setup
              </h3>

              <StepCard number={1} title="Create Account" darkMode={darkMode}>
                Sign up for your FilingStack account.
              </StepCard>

              <StepCard number={2} title="Log In" darkMode={darkMode}>
                Access your account.
              </StepCard>

              <StepCard
                number={3}
                title="Select Demo Company"
                darkMode={darkMode}
              >
                Click the <strong>Demo company</strong> on the{" "}
                <a
                  style={{
                    color: darkMode ? "#60a5fa" : "#0891b2",
                    textDecoration: "underline",
                  }}
                  href="./AfterLoginPage"
                  target="_blank"
                  rel="noreferrer"
                >
                  Info
                </a>{" "}
                page. You must always have a company selected.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="My Entities Page Visual"
                    src={DisplayImage("InfoPage.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <div
                style={{
                  backgroundColor: darkMode ? "#1e3a8a" : "#dbeafe",
                  padding: "16px",
                  borderRadius: "8px",
                  border: `1px solid ${darkMode ? "#1e40af" : "#93c5fd"}`,
                  marginBottom: "24px",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    color: darkMode ? "#bfdbfe" : "#1d4ed8",
                    fontSize: "0.95rem",
                  }}
                >
                  💡 <strong>Next Steps:</strong> Follow these steps to generate
                  your accounting reports (trial balance, ledger, financial
                  statements). See below for invoice and VAT guidance, or
                  contact support if you need help.
                </p>
              </div>

              <StepCard number={4} title="Add Bank Account" darkMode={darkMode}>
                Go to the{" "}
                <a
                  style={{
                    color: darkMode ? "#60a5fa" : "#0891b2",
                    textDecoration: "underline",
                  }}
                  href="./Accounts"
                  target="_blank"
                  rel="noreferrer"
                >
                  Accounts
                </a>{" "}
                page to add your bank account.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="Add Bank Account Visual"
                    src={DisplayImage("AddBankAccount.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <StepCard
                number={5}
                title="Upload Bank Statements"
                darkMode={darkMode}
              >
                Upload your bank statements in CSV format on the Accounts page.
                Click 'Choose file' then 'Upload file'.{" "}
                <span
                  style={{
                    fontWeight: "bold",
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: darkMode ? "#60a5fa" : "#0891b2",
                  }}
                  onClick={DownloadCSV}
                >
                  Download sample CSV
                </span>{" "}
                for reference. Get CSV files from your online banking or convert
                PDF statements.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="Upload File Visual"
                    src={DisplayImage("UploadFile.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <StepCard
                number={6}
                title="Allocate Transactions"
                darkMode={darkMode}
              >
                Assign each transaction to an account and click{" "}
                <strong>Save</strong> on the Accounts page.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="Allocate Accounts Visual"
                    src={DisplayImage("AllocateAccounts.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <StepCard number={7} title="Review Reports" darkMode={darkMode}>
                Check the{" "}
                <a
                  style={{
                    color: darkMode ? "#60a5fa" : "#0891b2",
                    textDecoration: "underline",
                  }}
                  href="./Tbalance"
                  target="_blank"
                  rel="noreferrer"
                >
                  Trial Balance
                </a>{" "}
                and{" "}
                <a
                  style={{
                    color: darkMode ? "#60a5fa" : "#0891b2",
                    textDecoration: "underline",
                  }}
                  href="./Ledger"
                  target="_blank"
                  rel="noreferrer"
                >
                  Ledger
                </a>{" "}
                pages to review your data.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="Trial Balance Visual"
                    src={DisplayImage("TrialBalance.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <StepCard
                number={8}
                title="Add Journals (if needed)"
                darkMode={darkMode}
              >
                Post any required journal entries on the{" "}
                <a
                  style={{
                    color: darkMode ? "#60a5fa" : "#0891b2",
                    textDecoration: "underline",
                  }}
                  href="./journals"
                  target="_blank"
                  rel="noreferrer"
                >
                  Journals
                </a>{" "}
                page.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="Journals Visual"
                    src={DisplayImage("journals.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <StepCard
                number={9}
                title="Customize Account Names"
                darkMode={darkMode}
              >
                Use the SOFP, SOCI, SOCE, and Cash Flow pages to edit account
                names for your financial statements.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="SOFP Visual"
                    src={DisplayImage("soCI.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <StepCard
                number={10}
                title="Add Reports & Notes"
                darkMode={darkMode}
              >
                Use the Reports link to add content to the beginning of your
                AFS, and the Notes page for additional notes at the end.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="Reports Visual"
                    src={DisplayImage("reports.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <StepCard
                number={11}
                title="Update Company Settings"
                darkMode={darkMode}
              >
                Change company name and details: Go to Settings link →{" "}
                <a
                  style={{
                    color: darkMode ? "#60a5fa" : "#0891b2",
                    textDecoration: "underline",
                  }}
                  href="./settings"
                  target="_blank"
                  rel="noreferrer"
                >
                  Settings
                </a>{" "}
                page.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="Settings Visual"
                    src={DisplayImage("settings.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <StepCard
                number={12}
                title="Generate PDF Reports"
                darkMode={darkMode}
              >
                Print your Annual Financial Statement (AFS) as PDF from the{" "}
                <a
                  style={{
                    color: darkMode ? "#60a5fa" : "#0891b2",
                    textDecoration: "underline",
                  }}
                  href="./PdfDisplay"
                  target="_blank"
                  rel="noreferrer"
                >
                  AFS
                </a>{" "}
                page.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="AFS Visual"
                    src={DisplayImage("afs.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <StepCard
                number={13}
                title="Add More Companies"
                darkMode={darkMode}
              >
                Use the Add Entity link on the My Entities page.{" "}
                <a
                  style={{
                    color: darkMode ? "#60a5fa" : "#0891b2",
                    textDecoration: "underline",
                  }}
                  target="_blank"
                  rel="noreferrer"
                  href={"https://youtu.be/wBploRRT5uo"}
                >
                  Watch video tutorial
                </a>{" "}
                for adding companies.
              </StepCard>

              <div style={{ textAlign: "left", margin: "24px 0" }}>
                {LoadingCheck(
                  <img
                    alt="Payments Visual 1"
                    src={DisplayImage("payments.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                      marginBottom: "15px",
                    }}
                  />
                )}
                {LoadingCheck(
                  <img
                    alt="Payments Visual 2"
                    src={DisplayImage("payments1.png")}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                )}
              </div>

              <StepCard
                number={14}
                title="Switch Between Companies"
                darkMode={darkMode}
              >
                After adding a company, select it on the{" "}
                <a
                  style={{
                    color: darkMode ? "#60a5fa" : "#0891b2",
                    textDecoration: "underline",
                  }}
                  href="./AfterLoginPage"
                  target="_blank"
                  rel="noreferrer"
                >
                  My Entities &gt;&gt; Company &amp; Clients
                </a>{" "}
                page by clicking its name. Then follow steps 4-11 above.
              </StepCard>
            </div>
          </DocSection>

          {/* Section 20: Quickstart videos */}
          <DocSection
            id="20"
            title="Video Tutorials"
            emoji="🎥"
            darkMode={darkMode}
            isCollapsed={collapsedSections.supportTicket}
            onToggle={() => toggleSection("supportTicket")}
          >
            <div
              style={{
                backgroundColor: "#fef2f2",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #fecaca",
                marginBottom: "32px",
              }}
            >
              <h4
                style={{
                  color: "#991b1b",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🎥 Video Tutorial Series
              </h4>
              <p style={{ color: "#dc2626", margin: 0 }}>
                An overview of FilingStack Accounting software.
              </p>
            </div>

            <div style={{ marginBottom: "40px" }}>
              <iframe
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                }}
                height="315"
                src="https://www.youtube.com/embed/QUWSqB0SP3M?si=l2HQEmmAKLcET7Fw"
                title="FilingStack Overview"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>

            {/* <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              📤 How to upload bank statements
            </h3>
            <div style={{ marginBottom: "40px" }}>
              <iframe
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                }}
                height="315"
                src="https://www.youtube.com/embed/zQf7mQkCeUE"
                title="Upload Bank Statements"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div> */}

            {/* <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              🏢 How to add a company to your profile
            </h3>
            <div style={{ marginBottom: "40px" }}>
              <iframe
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                }}
                height="315"
                src="https://www.youtube.com/embed/wBploRRT5uo"
                title="Add Company"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
              />
            </div> */}

            {/* <h3
              style={{
                color: "#1e293b",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              ⚙️ How to process bank statement transactions
            </h3>
            <div style={{ marginBottom: "40px" }}>
              <iframe
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                }}
                height="315"
                src="https://www.youtube.com/embed/ZLYIzV4JeV4"
                title="Process Transactions"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
              />
            </div> */}
          </DocSection>

          {/* Section 21: Advertising */}
          <DocSection
            id="21"
            title="Practice Directory Listing"
            emoji="📢"
            darkMode={darkMode}
            isCollapsed={collapsedSections.bankBalances}
            onToggle={() => toggleSection("bankBalances")}
          >
            <div
              style={{
                backgroundColor: darkMode ? "#164e63" : "#f0f9ff",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#0e7490" : "#7dd3fc"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#67e8f9" : "#0c4a6e",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                📢 Advertise Your Practice
              </h4>
              <p style={{ color: darkMode ? "#22d3ee" : "#0891b2", margin: 0 }}>
                If you run an accounting practice, click{" "}
                <strong>Advertise</strong> on the Dashboard to add your details.
                This lists your practice on our{" "}
                <strong>Accounting Practice Directory</strong>, helping you gain
                more clients.
              </p>
            </div>
          </DocSection>

          {/* Section 22: Enterprise Task Management */}
          <DocSection
            id="22"
            title="Enterprise Task Management"
            emoji="🚀"
            darkMode={darkMode}
            isCollapsed={collapsedSections.csvDataPage}
            onToggle={() => toggleSection("csvDataPage")}
          >
            <div
              style={{
                backgroundColor: "#faf5ff",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #a855f7",
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: "#6b21a8",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🚀 Advanced Task Management Features
              </h4>
              <p style={{ color: "#7c3aed", margin: 0 }}>
                The TasksDetails page has been enhanced with enterprise-grade
                features including bulk operations, real-time collaboration,
                advanced analytics, and powerful automation tools to streamline
                your workflow.
              </p>
            </div>

            {/* Bulk Import/Export Section */}
            <div
              style={{
                backgroundColor: "#f0f9ff",
                padding: "24px",
                borderRadius: "12px",
                border: "1px solid #3b82f6",
                marginBottom: "32px",
              }}
            >
              <h3
                style={{
                  color: "#1e40af",
                  marginBottom: "16px",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                }}
              >
                📊 Bulk Import & Export
              </h3>
              <div style={{ marginBottom: "20px" }}>
                <h4
                  style={{
                    color: "#1e40af",
                    marginBottom: "8px",
                    fontSize: "1.1rem",
                  }}
                >
                  CSV Import Features:
                </h4>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  <li style={{ marginBottom: "8px", color: "#1e40af" }}>
                    <strong>Drag & Drop Upload:</strong> Simply drag CSV files
                    directly onto the import area
                  </li>
                  <li style={{ marginBottom: "8px", color: "#1e40af" }}>
                    <strong>Real-time Progress:</strong> Visual progress bar
                    shows upload status with percentage completion
                  </li>
                  <li style={{ marginBottom: "8px", color: "#1e40af" }}>
                    <strong>Data Validation:</strong> Automatic checking for
                    required fields and data format
                  </li>
                  <li style={{ marginBottom: "8px", color: "#1e40af" }}>
                    <strong>Error Handling:</strong> Clear error messages with
                    suggestions for fixing data issues
                  </li>
                  <li style={{ marginBottom: "8px", color: "#1e40af" }}>
                    <strong>Template Downloads:</strong> Pre-configured CSV
                    templates for tasks and clients
                  </li>
                </ul>
              </div>
              <div style={{ marginBottom: "20px" }}>
                <h4
                  style={{
                    color: "#1e40af",
                    marginBottom: "8px",
                    fontSize: "1.1rem",
                  }}
                >
                  Export Options:
                </h4>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  <li style={{ marginBottom: "8px", color: "#1e40af" }}>
                    <strong>Filtered Exports:</strong> Export only the data
                    currently visible after applying filters
                  </li>
                  <li style={{ marginBottom: "8px", color: "#1e40af" }}>
                    <strong>Multiple Formats:</strong> CSV, Excel, and PDF
                    export options
                  </li>
                  <li style={{ marginBottom: "8px", color: "#1e40af" }}>
                    <strong>Custom Columns:</strong> Select which fields to
                    include in your export
                  </li>
                  <li style={{ marginBottom: "8px", color: "#1e40af" }}>
                    <strong>Batch Processing:</strong> Export thousands of
                    records efficiently
                  </li>
                </ul>
              </div>
              <div
                style={{
                  backgroundColor: "#dbeafe",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #93c5fd",
                }}
              >
                <p style={{ margin: 0, color: "#1e40af", fontWeight: "500" }}>
                  💡 <strong>Pro Tip:</strong> Use the sample templates
                  available in the public folder to ensure your CSV files have
                  the correct format before importing.
                </p>
              </div>
            </div>

            {/* Real-time Collaboration Section */}
            <div
              style={{
                backgroundColor: "#f0fdf4",
                padding: "24px",
                borderRadius: "12px",
                border: "1px solid #22c55e",
                marginBottom: "32px",
              }}
            >
              <h3
                style={{
                  color: "#15803d",
                  marginBottom: "16px",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                }}
              >
                👥 Real-time Collaboration
              </h3>
              <div style={{ marginBottom: "20px" }}>
                <h4
                  style={{
                    color: "#15803d",
                    marginBottom: "8px",
                    fontSize: "1.1rem",
                  }}
                >
                  Live User Indicators:
                </h4>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  <li style={{ marginBottom: "8px", color: "#15803d" }}>
                    <strong>Active User Count:</strong> See how many team
                    members are currently viewing the page
                  </li>
                  <li style={{ marginBottom: "8px", color: "#15803d" }}>
                    <strong>User Avatars:</strong> Visual indicators showing
                    who's online with profile pictures
                  </li>
                  <li style={{ marginBottom: "8px", color: "#15803d" }}>
                    <strong>Real-time Updates:</strong> Changes made by other
                    users appear instantly
                  </li>
                  <li style={{ marginBottom: "8px", color: "#15803d" }}>
                    <strong>Conflict Prevention:</strong> Smart locking prevents
                    multiple users from editing the same record
                  </li>
                </ul>
              </div>
              <div
                style={{
                  backgroundColor: "#dcfce7",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #86efac",
                }}
              >
                <p style={{ margin: 0, color: "#15803d", fontWeight: "500" }}>
                  🔄 <strong>Live Sync:</strong> All changes are synchronized
                  across all connected devices in real-time, ensuring everyone
                  always sees the latest data.
                </p>
              </div>
            </div>

            {/* Keyboard Shortcuts Section */}
            <div
              style={{
                backgroundColor: "#fef7ff",
                padding: "24px",
                borderRadius: "12px",
                border: "1px solid #d946ef",
                marginBottom: "32px",
              }}
            >
              <h3
                style={{
                  color: "#a21caf",
                  marginBottom: "16px",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                }}
              >
                ⌨️ Keyboard Shortcuts & Accessibility
              </h3>
              <div style={{ marginBottom: "20px" }}>
                <h4
                  style={{
                    color: "#a21caf",
                    marginBottom: "8px",
                    fontSize: "1.1rem",
                  }}
                >
                  Essential Shortcuts:
                </h4>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    gap: "12px",
                    marginBottom: "16px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fae8ff",
                      borderRadius: "6px",
                    }}
                  >
                    <span style={{ color: "#a21caf", fontWeight: "500" }}>
                      Create New Task
                    </span>
                    <kbd
                      style={{
                        backgroundColor: "#e879f9",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "0.9rem",
                      }}
                    >
                      Ctrl + N
                    </kbd>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fae8ff",
                      borderRadius: "6px",
                    }}
                  >
                    <span style={{ color: "#a21caf", fontWeight: "500" }}>
                      Save Changes
                    </span>
                    <kbd
                      style={{
                        backgroundColor: "#e879f9",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "0.9rem",
                      }}
                    >
                      Ctrl + S
                    </kbd>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fae8ff",
                      borderRadius: "6px",
                    }}
                  >
                    <span style={{ color: "#a21caf", fontWeight: "500" }}>
                      Search Tasks
                    </span>
                    <kbd
                      style={{
                        backgroundColor: "#e879f9",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "0.9rem",
                      }}
                    >
                      Ctrl + F
                    </kbd>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fae8ff",
                      borderRadius: "6px",
                    }}
                  >
                    <span style={{ color: "#a21caf", fontWeight: "500" }}>
                      Toggle Filters
                    </span>
                    <kbd
                      style={{
                        backgroundColor: "#e879f9",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "0.9rem",
                      }}
                    >
                      Ctrl + H
                    </kbd>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fae8ff",
                      borderRadius: "6px",
                    }}
                  >
                    <span style={{ color: "#a21caf", fontWeight: "500" }}>
                      Delete Task
                    </span>
                    <kbd
                      style={{
                        backgroundColor: "#e879f9",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "0.9rem",
                      }}
                    >
                      Delete
                    </kbd>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fae8ff",
                      borderRadius: "6px",
                    }}
                  >
                    <span style={{ color: "#a21caf", fontWeight: "500" }}>
                      Bulk Select
                    </span>
                    <kbd
                      style={{
                        backgroundColor: "#e879f9",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "0.9rem",
                      }}
                    >
                      Ctrl + A
                    </kbd>
                  </div>
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#f3e8ff",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #c084fc",
                }}
              >
                <p style={{ margin: 0, color: "#a21caf", fontWeight: "500" }}>
                  ♿ <strong>Accessibility:</strong> Full keyboard navigation
                  support, screen reader compatibility, and high contrast mode
                  for improved accessibility.
                </p>
              </div>
            </div>

            {/* Custom Fields Section */}
            <div
              style={{
                backgroundColor: "#fff7ed",
                padding: "24px",
                borderRadius: "12px",
                border: "1px solid #fb923c",
                marginBottom: "32px",
              }}
            >
              <h3
                style={{
                  color: "#c2410c",
                  marginBottom: "16px",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                }}
              >
                🎛️ Custom Fields & Configuration
              </h3>
              <div style={{ marginBottom: "20px" }}>
                <h4
                  style={{
                    color: "#c2410c",
                    marginBottom: "8px",
                    fontSize: "1.1rem",
                  }}
                >
                  Dynamic Field Management:
                </h4>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  <li style={{ marginBottom: "8px", color: "#c2410c" }}>
                    <strong>Add Custom Fields:</strong> Create additional fields
                    specific to your business needs
                  </li>
                  <li style={{ marginBottom: "8px", color: "#c2410c" }}>
                    <strong>Field Types:</strong> Text, numbers, dates,
                    dropdowns, checkboxes, and file uploads
                  </li>
                  <li style={{ marginBottom: "8px", color: "#c2410c" }}>
                    <strong>Validation Rules:</strong> Set required fields,
                    format restrictions, and value ranges
                  </li>
                  <li style={{ marginBottom: "8px", color: "#c2410c" }}>
                    <strong>Conditional Logic:</strong> Show/hide fields based
                    on other field values
                  </li>
                  <li style={{ marginBottom: "8px", color: "#c2410c" }}>
                    <strong>Field Ordering:</strong> Drag and drop to reorder
                    fields in your preferred layout
                  </li>
                </ul>
              </div>
              <div
                style={{
                  backgroundColor: "#fed7aa",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #fdba74",
                }}
              >
                <p style={{ margin: 0, color: "#c2410c", fontWeight: "500" }}>
                  🔧 <strong>Configuration:</strong> All custom field settings
                  are saved per user and automatically sync across all your
                  devices.
                </p>
              </div>
            </div>

            {/* Analytics Section */}
            <div
              style={{
                backgroundColor: "#f0fdfa",
                padding: "24px",
                borderRadius: "12px",
                border: "1px solid #2dd4bf",
                marginBottom: "32px",
              }}
            >
              <h3
                style={{
                  color: "#0f766e",
                  marginBottom: "16px",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                }}
              >
                📈 Per-User Analytics & Insights
              </h3>
              <div style={{ marginBottom: "20px" }}>
                <h4
                  style={{
                    color: "#0f766e",
                    marginBottom: "8px",
                    fontSize: "1.1rem",
                  }}
                >
                  Comprehensive Analytics Dashboard:
                </h4>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  <li style={{ marginBottom: "8px", color: "#0f766e" }}>
                    <strong>Task Completion Rates:</strong> Track productivity
                    with detailed completion statistics
                  </li>
                  <li style={{ marginBottom: "8px", color: "#0f766e" }}>
                    <strong>Time Tracking:</strong> Monitor time spent on
                    different types of tasks
                  </li>
                  <li style={{ marginBottom: "8px", color: "#0f766e" }}>
                    <strong>User Performance:</strong> Individual and team
                    performance metrics
                  </li>
                  <li style={{ marginBottom: "8px", color: "#0f766e" }}>
                    <strong>Workload Distribution:</strong> Visual charts
                    showing task allocation across team members
                  </li>
                  <li style={{ marginBottom: "8px", color: "#0f766e" }}>
                    <strong>Trend Analysis:</strong> Historical data showing
                    productivity trends over time
                  </li>
                  <li style={{ marginBottom: "8px", color: "#0f766e" }}>
                    <strong>Custom Reports:</strong> Generate detailed reports
                    for specific time periods or criteria
                  </li>
                </ul>
              </div>
              <div
                style={{
                  backgroundColor: "#ccfbf1",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #5eead4",
                }}
              >
                <p style={{ margin: 0, color: "#0f766e", fontWeight: "500" }}>
                  📊 <strong>Data Privacy:</strong> All analytics are processed
                  securely and individual user data remains private to
                  authorized users only.
                </p>
              </div>
            </div>

            {/* Date Filtering Section */}
            <div
              style={{
                backgroundColor: "#fef2f2",
                padding: "24px",
                borderRadius: "12px",
                border: "1px solid #f87171",
                marginBottom: "32px",
              }}
            >
              <h3
                style={{
                  color: "#dc2626",
                  marginBottom: "16px",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                }}
              >
                📅 Advanced Date Filtering
              </h3>
              <div style={{ marginBottom: "20px" }}>
                <h4
                  style={{
                    color: "#dc2626",
                    marginBottom: "8px",
                    fontSize: "1.1rem",
                  }}
                >
                  Flexible Date Range Options:
                </h4>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  <li style={{ marginBottom: "8px", color: "#dc2626" }}>
                    <strong>Quick Presets:</strong> Today, This Week, This
                    Month, Last 30 Days, Quarter, Year
                  </li>
                  <li style={{ marginBottom: "8px", color: "#dc2626" }}>
                    <strong>Custom Date Ranges:</strong> Select any start and
                    end date combination
                  </li>
                  <li style={{ marginBottom: "8px", color: "#dc2626" }}>
                    <strong>Multiple Date Fields:</strong> Filter by created
                    date, due date, completed date, or modified date
                  </li>
                  <li style={{ marginBottom: "8px", color: "#dc2626" }}>
                    <strong>Relative Filtering:</strong> "Due in next 7 days",
                    "Overdue tasks", "Recently completed"
                  </li>
                  <li style={{ marginBottom: "8px", color: "#dc2626" }}>
                    <strong>Save Filter Presets:</strong> Save commonly used
                    date filters for quick access
                  </li>
                </ul>
              </div>
              <div
                style={{
                  backgroundColor: "#fecaca",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #fca5a5",
                }}
              >
                <p style={{ margin: 0, color: "#dc2626", fontWeight: "500" }}>
                  ⏰ <strong>Smart Defaults:</strong> The system remembers your
                  preferred date filters and applies them automatically on
                  subsequent visits.
                </p>
              </div>
            </div>

            {/* Getting Started Section */}
            <div
              style={{
                backgroundColor: "#f8fafc",
                padding: "24px",
                borderRadius: "12px",
                border: "2px solid #64748b",
                marginBottom: "32px",
              }}
            >
              <h3
                style={{
                  color: "#334155",
                  marginBottom: "16px",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                }}
              >
                🚀 Getting Started with Enterprise Features
              </h3>
              <div style={{ marginBottom: "20px" }}>
                <h4
                  style={{
                    color: "#334155",
                    marginBottom: "12px",
                    fontSize: "1.1rem",
                  }}
                >
                  Quick Setup Guide:
                </h4>
                <ol style={{ paddingLeft: "20px", margin: 0 }}>
                  <li style={{ marginBottom: "12px", color: "#334155" }}>
                    <strong>Navigate to TasksDetails:</strong> Access the
                    enhanced task management page from your dashboard
                  </li>
                  <li style={{ marginBottom: "12px", color: "#334155" }}>
                    <strong>Configure Custom Fields:</strong> Set up any
                    additional fields your business requires
                  </li>
                  <li style={{ marginBottom: "12px", color: "#334155" }}>
                    <strong>Import Your Data:</strong> Use the bulk import
                    feature to upload existing task data
                  </li>
                  <li style={{ marginBottom: "12px", color: "#334155" }}>
                    <strong>Set Up Team Access:</strong> Invite team members and
                    configure collaboration settings
                  </li>
                  <li style={{ marginBottom: "12px", color: "#334155" }}>
                    <strong>Learn Shortcuts:</strong> Practice the keyboard
                    shortcuts to improve your efficiency
                  </li>
                  <li style={{ marginBottom: "12px", color: "#334155" }}>
                    <strong>Explore Analytics:</strong> Review the analytics
                    dashboard to understand your workflow patterns
                  </li>
                </ol>
              </div>
              <div
                style={{
                  backgroundColor: "#e2e8f0",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                }}
              >
                <p style={{ margin: 0, color: "#334155", fontWeight: "500" }}>
                  💼 <strong>Enterprise Support:</strong> For advanced
                  configuration or training, contact our enterprise support team
                  for personalized assistance.
                </p>
              </div>
            </div>

            {/* Best Practices Section */}
            <div
              style={{
                backgroundColor: "#fffbeb",
                padding: "24px",
                borderRadius: "12px",
                border: "1px solid #fbbf24",
                marginBottom: "24px",
              }}
            >
              <h3
                style={{
                  color: "#d97706",
                  marginBottom: "16px",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                }}
              >
                💡 Best Practices & Tips
              </h3>
              <div style={{ marginBottom: "20px" }}>
                <h4
                  style={{
                    color: "#d97706",
                    marginBottom: "8px",
                    fontSize: "1.1rem",
                  }}
                >
                  Optimization Recommendations:
                </h4>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  <li style={{ marginBottom: "8px", color: "#d97706" }}>
                    <strong>Regular Exports:</strong> Schedule weekly exports to
                    maintain data backups
                  </li>
                  <li style={{ marginBottom: "8px", color: "#d97706" }}>
                    <strong>Filter Usage:</strong> Use date filters to focus on
                    relevant time periods and improve performance
                  </li>
                  <li style={{ marginBottom: "8px", color: "#d97706" }}>
                    <strong>Bulk Operations:</strong> Process multiple tasks at
                    once using bulk selection features
                  </li>
                  <li style={{ marginBottom: "8px", color: "#d97706" }}>
                    <strong>Custom Fields:</strong> Only add custom fields that
                    you'll actively use to keep the interface clean
                  </li>
                  <li style={{ marginBottom: "8px", color: "#d97706" }}>
                    <strong>Collaboration:</strong> Use real-time features
                    during team meetings for live updates
                  </li>
                  <li style={{ marginBottom: "8px", color: "#d97706" }}>
                    <strong>Analytics Review:</strong> Check analytics weekly to
                    identify workflow bottlenecks
                  </li>
                </ul>
              </div>
              <div
                style={{
                  backgroundColor: "#fef3c7",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #fcd34d",
                }}
              >
                <p style={{ margin: 0, color: "#d97706", fontWeight: "500" }}>
                  🎯 <strong>Performance Tip:</strong> For large datasets (1000+
                  tasks), use date filtering to improve page load times and
                  system responsiveness.
                </p>
              </div>
              ``
            </div>
          </DocSection>

          {/* Section 23: Collaboration & Engagement */}
          <DocSection
            id="23"
            title="Collaboration & Engagement Workflows"
            emoji="🤝"
            darkMode={darkMode}
            isCollapsed={collapsedSections.supportTicket}
            onToggle={() => toggleSection("supportTicket")}
          >
            <RecentWorkflowGuide guideKey="migration" darkMode={darkMode} />
            <RecentWorkflowGuide guideKey="collaboration" darkMode={darkMode} />
            <p><a href="#25">Read the complete Client Portal guide for accountants and clients.</a></p>
            <div
              style={{
                backgroundColor: darkMode ? "#0f172a" : "#f8fafc",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#334155" : "#cbd5e1"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#e2e8f0" : "#0f172a",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                🌐 End-to-End Client Workflows
              </h4>
              <p style={{ color: darkMode ? "#cbd5e1" : "#334155", margin: 0 }}>
                FilingStack includes dedicated modules for onboarding,
                collaboration, audit preparation, and engagement management.
                These are useful when your firm works directly with clients on
                deliverables and approval steps.
              </p>
            </div>

            <FeatureHighlight
              title="Where to Use Each Module"
              darkMode={darkMode}
              features={[
                "📥 Migration Onboarding - Capture onboarding requirements and migration progress",
                "🤝 Client Collaboration - Share requests and updates with clients in one place",
                "📝 Engagement Letters - Generate and track engagement documentation",
                "🔐 Engagement Portal - Manage client-facing engagement steps",
                "🧾 Audit Portal - Coordinate audit support files and responses",
              ]}
            />

            <StepCard
              number="1"
              title="Recommended sequence for new clients"
              darkMode={darkMode}
            >
              <ol style={{ paddingLeft: "20px", margin: "12px 0" }}>
                <li style={{ marginBottom: "8px" }}>
                  Start in <strong>Migration Onboarding</strong> to collect
                  source-system and opening data details.
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Create the relationship terms in <strong>Engagement
                  Letters</strong>.
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Move ongoing communication to <strong>Client
                  Collaboration</strong> for file requests and status updates.
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Use <strong>Audit Portal</strong> when preparing for external
                  review and evidence sharing.
                </li>
              </ol>
            </StepCard>

            <div
              style={{
                backgroundColor: darkMode ? "#064e3b" : "#ecfdf5",
                padding: "20px",
                borderRadius: "12px",
                border: `1px solid ${darkMode ? "#065f46" : "#86efac"}`,
                marginBottom: "24px",
              }}
            >
              <h4
                style={{
                  color: darkMode ? "#6ee7b7" : "#065f46",
                  marginBottom: "12px",
                  fontSize: "1.1rem",
                }}
              >
                ✅ User success checklist
              </h4>
              <ul
                style={{
                  color: darkMode ? "#a7f3d0" : "#047857",
                  paddingLeft: "20px",
                  margin: 0,
                }}
              >
                <li>Confirm the correct entity is selected before starting work</li>
                <li>Enable audit logs in User Profile for better traceability</li>
                <li>Use tasks to assign owners and due dates for client requests</li>
                <li>Keep engagement documents and communications in-platform</li>
              </ul>
            </div>
          </DocSection>

          <DocSection id="24" title="CIPC Automation — Complete Guide" number="24" darkMode={darkMode}
            isCollapsed={collapsedSections.cipcGuide} onToggle={() => toggleSection("cipcGuide")}>
            <PortalGuide guideKey="cipc" darkMode={darkMode} />
          </DocSection>

          <DocSection id="25" title="Client Portal — Complete Guide" number="25" darkMode={darkMode}
            isCollapsed={collapsedSections.clientPortalGuide} onToggle={() => toggleSection("clientPortalGuide")}>
            <PortalGuide guideKey="clientPortal" darkMode={darkMode} />
          </DocSection>

          <div
            style={{
              margin: "32px 0",
              padding: "24px",
              backgroundColor: darkMode ? "#1e293b" : "#eff6ff",
              border: `1px solid ${darkMode ? "#475569" : "#bfdbfe"}`,
              borderRadius: "12px",
              textAlign: "center",
            }}
          >
            <p
              style={{
                color: darkMode ? "#cbd5e1" : "#334155",
                margin: "0 0 14px",
              }}
            >
              Looking for professional competence study resources?
            </p>
            <Link
              to="/accountingmaterial"
              style={{
                color: darkMode ? "#93c5fd" : "#1d4ed8",
                fontWeight: 700,
                textDecoration: "underline",
              }}
            >
              Visit the APC Study Hub
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsageInfo;
